import {
  Component,
  PLATFORM_ID,
  NgZone,
  ViewChildren,
  QueryList,
  ElementRef,
  ChangeDetectorRef,
  AfterViewInit,
  OnInit,
  OnDestroy,
  Renderer2,
  RendererStyleFlags2,
  ViewChild,
  HostListener,
} from '@angular/core';
import {
  AngularfirestoreCoolStoreService,
  AngularfirestorePerfectStoreService,
} from './services/angularfirestore-extension.service';
import { Observable } from 'rxjs';
import { FirebaseService } from './services/firebase.service';
const customer = 'kunde1001';

import { AngularFirestore } from '@angular/fire/firestore';
import { CustomerdatabaseService } from './services/customerdatabase.service';
import { ProfileService } from './services/profile.service';
import { TutorialService } from './services/tutorial.service';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { TranslationObject } from './core/helper/TranslationObject';
import { MenuService } from './services/menu-service';
import { AGENT_PRICING_ROUTE, isMonaAdminEmail } from './admin/pricing/pricing-model';
import { ArsService, ArsSearch } from './services/ars.service';
import { arsEmbedReturnUrl, initArsEmbedShell, isArsEmbedContext, shouldStayInsideEmbed } from './ars-embed/ars-embed-context';
import { ShortlistService } from './services/shortlist.service';
import { WorkspaceTabService, PINNED_HOME_ID } from './services/workspace-tab.service';
import { ThemeService } from './services/theme.service';
import { CreditMonitorService } from './services/credit-monitor.service';
import { MenuController, Platform, AlertController, LoadingController, ToastController, ModalController } from '@ionic/angular';
import { OnboardingService } from './services/onboarding.service';
import { PlatformTourService } from './shared/platform-tour/platform-tour.service';
import { buildPlatformTourSteps } from './shared/platform-tour/platform-tour-steps';
import { profile } from 'console';
import { NavigationEnd } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { UserJourneyAnalyticsService } from './services/tracking/user-journey-analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { translations } from './core/helper/translations';
import { resolvePlatformLanguage } from './core/helper/platform-language.helper';
import { isPartnerLaunch } from './ars-embed/partner-launch-sandbox';
import { ImportantMessagesModalComponent } from './components/important-messages-modal/important-messages-modal.component';
import * as toolInfos from './mona-agent-builder/tool_infos_mapping.json';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {
  logoBig = '../assets/mona_white_logo.png';
  logoSmall = '../assets/mona.PNG';
  public loginFinished = false;
  ProfileIcon = '';
  coolClctn$: Observable<any>;
  perfectClctn$: Observable<any>;
  currentUser: any;
  intern = false;
  isAuthenticated: boolean = false;
  admin = '';
  adminBool = false;
  creditsRemaining: number;
  public applicantsRemaining: number;
  enterprise = false;
  currentPlan = '';
  profilePicture = '../assets/icon/megaphone-outline.png';
  public appPages = [];
  public appPages2 = [];


  public workforcePages = [];
  public platformPages = [];
  public organizationPages = [];
  public personalButtons = [
    // { title: "WasGibtsNeues", url: '/news', photo: '../assets/icon/megaphone-outline.png' },
    // { title: "NeustartTutorial", url: '/dashboard', photo: '../assets/icon/tutorial.png' },
    // { title: 'HowToVideos', url: '/howto', photo: '../assets/icon/play-skip-forward-outline.png' },
    // { title: 'Hilfe', url: '/help', photo: '../assets/icon/help-circle-outline.png' },
    // { title: 'AccountEinstellungen', url: '/profile', photo: '../assets/icon/settings-outline.png' },
    { title: 'AccountEinstellungen', url: '/profile', icon: 'settings' },
  ];
  //
  @ViewChildren('itemRef', { read: ElementRef })
  itemRefs: QueryList<ElementRef>;
  @ViewChild('mainOutlet', { read: ElementRef }) outlet: ElementRef;

  private readonly UPDATE_MESSAGES_ADMIN_UID = 'YHHSoY2I7BdR9rpsaKkD7YWDRgA3';
  isUpdateMessagesAdmin: boolean = false;
  isInfoMonaUser: boolean = false;
  currentUserEmail: string = '';

  monaPlatform: boolean = true;
  monaWorkforce: boolean = true;
  monaOrganization: boolean = true;
  monaSupport: boolean = false;
  monaAutomations: boolean = false;
  monaSystem: boolean = true;
  monaSettings: boolean = false;
  collapsed: boolean = false;

  // to hold the click event that opens each popover
  platformEvent: any;
  workforceEvent: any;
  automationsEvent: any;
  supportEvent: any;

  businessName: string = '';
  lastLogin: any;
  currentItemName: string = 'Dashboard';
  currentUserExample = {
    name: 'Jane Doe',
    profilePicture: '../assets/icon/megaphone-outline.png', // Leave empty to display initials
  };
  businessLogo: string;
  businessNameOnlyFirstLetter: string = '';
  public iconsOnly = false;
  public isSmallScreen = false;
  public isEnterpriseCustomer = false;
  public isAgentsCustomerType = false;
  public isHybridCustomer = false;
  public isArsCustomerType = false;
  public hybridSearches: ArsSearch[] = [];
  public hybridSearchesExpanded = true;
  public hybridSearchFilter: string = '';
  public searchOptionsOpenId: string | null = null;
  public searchOptionsMenuTop: number = 0;
  public searchOptionsMenuLeft: number = 0;
  public searchRenameId: string | null = null;
  public searchRenameValue: string = '';
  public shortlistCount: number = 0;
  public hybridShortlistExpanded = false;

  get filteredHybridSearches(): ArsSearch[] {
    const searches = this.hybridSearches || [];
    if (!this.hybridSearchFilter.trim()) {
      return searches;
    }
    const q = this.hybridSearchFilter.toLowerCase();
    return searches.filter(s => s.query.toLowerCase().includes(q));
  }

  get currentLang(): string {
    return this.translateService?.currentLang || 'de';
  }
  public hybridContacts: { id: string; name: string; jobTitle: string }[] = [];
  public hybridContactsExpanded = false;
  public hybridArsExpanded = true;
  public showContactPanel = false;
  public selectedContactId = '';
  public isFreeAndAgentsCustomerType = false;
  public isSelfServiceCustomerType = false;
  
  // Menu resize drag properties
  private isDraggingMenuResize = false;
  private menuResizeStartX = 0;
  // Stable bound references so add/removeEventListener target the same function.
  private boundMenuResizeMove = (event: MouseEvent | TouchEvent) => this.onMenuResizeMove(event);
  private boundMenuResizeEnd = (event: MouseEvent | TouchEvent) => this.onMenuResizeEnd(event);
  private windowResizeDebounce: any = null;
  private lastWindowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
  private tooltipListeners: Map<Element, { enter: EventListener, leave: EventListener }> = new Map();
  private creditUsageHistory: { timestamp: number; credits: number }[] = [];
  private lastCreditCheck: number = Date.now();
  public showIntegrationsInMenu = false;
  public isEmbedRoute = initArsEmbedShell();
  public hideMenu = this.isEmbedRoute;
  public quickWinsPercent = 0;
  private quickWinsRedirecting = false;
  private readonly MENU_HIDE_BREAKPOINT = 1000;
  translationObject: { [key: string]: string } = { ...TranslationObject.TRANSLATION_OBJECT };
  private readonly organizationMenuTitles = ['Email Inbox', 'SMS Inbox', 'Data Pipeline', 'Process Manager', 'Database', 'MCP'];
  private getUniqueByUrl(items: any[]): any[] {
    const seen = new Set<string>();
    const result: any[] = [];
    (items || []).forEach((it: any) => {
      const key = it && it.url;
      if (key && !seen.has(key)) {
        seen.add(key);
        result.push(it);
      }
    });
    return result;
  }

  // Recent chats properties
  public recentChats: any[] = [];
  public recentChatsByAgent: { [agentId: string]: any[] } = {};
  public expandedAgents: { [agentId: string]: boolean } = {};
  public showRecentChats: boolean = true;
  public displayedChats: any[] = [];
  public chatsPerLoad: number = 10;
  public totalChatsLoaded: number = 0;
  public isLoadingMoreChats: boolean = false;
  public monariAgentNames: { [agentId: string]: string } = {};
  public monariAgentImages: { [agentId: string]: string } = {};

  // Computed properties for safe template rendering
  public get shouldShowRecentChats(): boolean {
    return (this.isAgentsCustomerType || this.isEnterpriseCustomer) && this.hasRecentChats;
  }

  public get hasRecentChats(): boolean {
    return this.displayedChats && this.displayedChats.length > 0;
  }

  private disableLoadingScreenTimeout() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      take(1)
    ).subscribe((event: NavigationEnd) => {
      var splash = document.getElementById('splash-screen');
      if (splash) {
        splash.classList.add('fade-out');
        setTimeout(function () {
          splash.remove();
        }, 300);
      }
    });
  }

  ngOnInit() {




    this.disableLoadingScreenTimeout();
    this.customerDB.isAuthenticatedOnCustDb$.pipe(filter(isAuth => isAuth), take(1)).subscribe((isAuth) => {
      console.log('[Translation] isAuthenticatedOnCustDb$ fired, isAuth:', isAuth);
      if (isAuth) {
        console.log('[Translation] Calling ensureBrandingProfileExists...');
        this.ensureBrandingProfileExists();
      }
    });
    // Global error handler for stack overflow protection
    window.addEventListener('error', (event) => {
      if (event.error && event.error.message &&
        (event.error.message.includes('Maximum call stack') ||
          event.error.message.includes('too much recursion'))) {
        console.error('[CRITICAL] Stack overflow detected! Reloading page to recover...');
        event.preventDefault();
        // Force reload the page after a short delay to recover
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    });

    // Load credit usage history from localStorage
    try {
      const storedHistory = localStorage.getItem('creditUsageHistory');
      if (storedHistory) {
        this.creditUsageHistory = JSON.parse(storedHistory);
      }
    } catch (e) {
      console.error('Failed to load credit history:', e);
    }

    this.setupUrlChangeListener();
    this.checkFromRedirect(this.getAdditionalParam());

    // Load menu state early to ensure it's available
    this.loadMenuState();
    this.menuStateInitListener = () => {
      this.loadMenuState();
      setTimeout(() => {
        // this.applyMenuState();
      }, 100);
    };
    window.addEventListener('menuStateInit', this.menuStateInitListener);

    // Make this component available globally for refreshing recent chats
    (window as any).appComponent = this;

    // Quick Wins progress listener and initial load
    window.addEventListener('quickWinsUpdated', this.onQuickWinsUpdated);
    try {
      const storedQuickWins = localStorage.getItem('quickWinsPercent');
      this.quickWinsPercent = storedQuickWins ? parseInt(storedQuickWins, 10) || 0 : 0;
    } catch {
      this.quickWinsPercent = 0;
    }


  }

  // Function that triggers on URL changes
  private setupUrlChangeListener() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.onUrlChange(event.url);
    });
  }

  // This function will be called every time the URL changes
  private onUrlChange(newUrl: string) {
    if (shouldStayInsideEmbed(newUrl)) {
      this.isEmbedRoute = true;
      this.hideMenu = true;
      this.menuCtrl.enable(false, 'main-menu');
      const target = arsEmbedReturnUrl();
      if (target) {
        this.router.navigateByUrl(target);
      }
      return;
    }
    if (this.isAuthenticated) {
      this.checkAndShowImportantMessages();
    }
    this.updateGlobalBarVisibility(newUrl);
    this.updateMenuVisibility(newUrl);
    this.checkUpgradeEligibility(newUrl);
    // this.applyMenuState();
    // Trigger Quick Wins popup via MenuService when routing
    try { this.menuService.triggerQuickWinsPopupIfNeeded(newUrl); } catch { }
    try { this.menuService.triggerOrganizationPopupIfNeeded(newUrl, this.currentPlan || ''); } catch { }
    if (!this.quickWinsRedirecting && newUrl && newUrl.indexOf('/quick-wins') !== -1) {
      const nextId = this.getNextQuickWinId();
      const route = this.mapQuickWinIdToRoute(nextId);
      if (route) {
        this.quickWinsRedirecting = true;
        try { localStorage.setItem('quickWinsContext', nextId); } catch { }
        this.router.navigate([route]).finally(() => {
          setTimeout(() => { this.quickWinsRedirecting = false; }, 300);
        });
      }
    }
  }

  private getNextQuickWinId(): string {
    const order = ['start-chat', 'start-chat-internet', 'start-browser-automation', 'create-agent', 'integrations', 'email-workflow', 'build-workflow', 'add-knowledge'];
    try {
      const stored = localStorage.getItem('quickWinsCompleted');
      const done: string[] = stored ? JSON.parse(stored) || [] : [];
      for (const id of order) {
        if (!done.includes(id)) return id;
      }
      return 'start-chat';
    } catch {
      return 'start-chat';
    }
  }

  private mapQuickWinIdToRoute(id: string): string | null {
    switch (id) {
      case 'start-chat': return '/agent-dashboard';
      case 'create-agent': return '/mona-agent-builder';
      case 'connect-email': return '/email-inbox';
      case 'build-workflow': return '/organigram';
      case 'add-knowledge': return '/mona-agent-chat';
      case 'integrations': return '/integrations';
      default: return null;
    }
  }

  openQuickWinsFooter() {
    const nextId = this.getNextQuickWinId();
    const route = this.mapQuickWinIdToRoute(nextId);
    if (route) {
      try { localStorage.setItem('quickWinsContext', nextId); } catch { }
      if (this.router.url && this.router.url.indexOf(route) !== -1) {
        try { this.menuService.triggerQuickWinsPopupIfNeeded(this.router.url); } catch { }
      } else {
        this.router.navigate([route]);
      }
    }
  }

  showAgentBuilder: boolean = false;
  newAgentBuilder: boolean = false;

  // when user picks a platform page
  onPlatformSelect(title: string) {
    const p = this.appPages.find(x => x.title === title);
    if (p) {
      // If Quick Wins clicked, route to next task
      if (p.url === '/quick-wins' || p.title === 'Quick Wins') {
        const nextId = this.getNextQuickWinId();
        const route = this.mapQuickWinIdToRoute(nextId);
        if (route) {
          try { localStorage.setItem('quickWinsContext', nextId); } catch { }
          if (this.router.url && this.router.url.indexOf(route) !== -1) {
            try { this.menuService.triggerQuickWinsPopupIfNeeded(this.router.url); } catch { }
          } else {
            this.router.navigate([route]);
          }
          return;
        }
      }
      // Mark applicants as viewed if navigating to Kandidaten page
      if (p.title === 'Kandidaten') {
        this.markApplicantsAsViewed();
      }
      this.router.navigate([p.url]);
    }
  }
  // workforce options
  onWorkforceSelect(val: string) {
    if (val === 'assistant') this.openMONAChat();
    else if (val === 'agents') this.openAIAgents();
  }

  onPlatformMenuClick(p: any) {
    this.chooseSubItem(p.title);
    if (p.state) {
      this.router.navigate([p.url], { state: p.state });
    }
  }

  onOrganizationMenuClick(p: any) {
    if (this.isFreeAndAgentsCustomerType || this.currentPlan === 'agents-free') {
      try { this.menuService.triggerOrganizationPopupIfNeeded(p?.url || '', this.currentPlan || 'agents-free'); } catch { }
      return; // prevent navigation
    }
    this.chooseSubItem(p.title);
    this.router.navigate([p.url]);
  }
  // automations options
  onAutomationsSelect(val: string) {
    if (val === 'integrationen') this.integrations();
  }
  // community/support options
  onSupportSelect(val: string) {
    if (val === 'tutorials') this.openTutorials();
    else if (val === 'user-handbook') this.openUserHandbook();
    else if (val === 'youtube') this.openYoutube();
    else if (val === 'support') this.openMONASupportLink();
  }

  toggleCollapse() { this.collapsed = !this.collapsed; }

  ngAfterViewInit() {
    const admin = this.authService.returnUserRole();
    console.log("!!!!!!!!!!!!!!!!!!!!!!!!!admin", admin);
    this.admin = admin;
    this.enterprise = true;
    this.adminBool = admin == 'admin' ? true : false;

    // Load menu state from localStorage
    this.loadMenuState();

    this.updateMenuVisibility(this.router.url);
    setTimeout(() => {
      // this.applyMenuState();
    }, 300);

    this.itemRefs.forEach((itemRef) => {
      if (itemRef.nativeElement.innerText == 'Stellenanzeigen') {
        const currentPage = this.router.url;
        const node = itemRef.nativeElement;
        this.authService.setData(node);
      }
    });

    this.authService.isAuthenticated$.subscribe(async (isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
      this.updateGlobalBarVisibility(this.router.url);
      if (this.isAuthenticated && this.router.url.includes('dashboard')) {
        this.chooseSubItem('Dashboard');
        // Removed background color setting to keep menu consistent
        // const dashboardEl = document.getElementById('Dashboard');
        // if (dashboardEl) dashboardEl.style.backgroundColor = '#F6F6F6';
      }
      this.cdr.detectChanges();
    });
    // this.menuService.AccountSettings$.subscribe((settings) => {
    //   this.personalButtons = settings;
    // });












    this.setIsAdmin();
    this.setAppPages();




    console.log("shouldShowSubscriptionChip", this.shouldShowSubscriptionChip());
    console.log("businessLogo", this.businessLogo);
    console.log("isAgentsCustomerType", this.isAgentsCustomerType);
    console.log("isEnterpriseCustomer", this.isEnterpriseCustomer);
    
    console.log("isFreeAndAgentsCustomerType", this.isFreeAndAgentsCustomerType);
    console.log("isSelfServiceCustomerType", this.isSelfServiceCustomerType);
    console.log("isEnterpriseCustomer", this.isEnterpriseCustomer);
    console.log("showNewApplicantsToast", this.showNewApplicantsToast);


    







    // Initialize real DOM tooltips for collapsed menu
    setTimeout(() => {
      this.initializeMenuTooltips();
    }, 1000);
  }

  private initializeMenuTooltips() {
    // Remove any existing tooltip
    const existingTooltip = document.getElementById('menu-tooltip');
    if (existingTooltip) existingTooltip.remove();
    
    // Remove old event listeners
    this.tooltipListeners.forEach((listeners, item) => {
      item.removeEventListener('mouseenter', listeners.enter);
      item.removeEventListener('mouseleave', listeners.leave);
    });
    this.tooltipListeners.clear();
    
    // If menu is not collapsed, don't initialize tooltips
    if (!this.iconsOnly) return;
    
    const menuItems = document.querySelectorAll('ion-menu .menu-item');
    
    menuItems.forEach((item: Element) => {
      const htmlItem = item as HTMLElement;
      
      const enterListener = (e: Event) => {
        // Only show tooltip when menu is collapsed
        if (!this.iconsOnly) return;
        
        const tooltipText = htmlItem.getAttribute('data-tooltip');
        if (!tooltipText) return;
        
        // Remove any existing tooltip
        const existingTooltip = document.getElementById('menu-tooltip');
        if (existingTooltip) existingTooltip.remove();
        
        // Create tooltip
        const tooltip = document.createElement('div');
        tooltip.id = 'menu-tooltip';
        tooltip.textContent = tooltipText;
        
        // Position tooltip
        const rect = htmlItem.getBoundingClientRect();
        tooltip.style.cssText = `
          position: fixed;
          left: ${rect.right + 10}px;
          top: ${rect.top + rect.height / 2}px;
          transform: translateY(-50%);
          background: #2b2f6c;
          color: white;
          padding: 8px 12px;
          border-radius: 8px;
          font-size: 13px;
          white-space: nowrap;
          z-index: 999999;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.2s ease;
        `;
        
        document.body.appendChild(tooltip);
        
        // Trigger animation
        setTimeout(() => {
          tooltip.style.opacity = '1';
        }, 10);
      };
      
      const leaveListener = () => {
        const tooltip = document.getElementById('menu-tooltip');
        if (tooltip) {
          tooltip.style.opacity = '0';
          setTimeout(() => tooltip.remove(), 200);
        }
      };
      
      htmlItem.addEventListener('mouseenter', enterListener);
      htmlItem.addEventListener('mouseleave', leaveListener);
      
      // Store listeners for cleanup
      this.tooltipListeners.set(htmlItem, { enter: enterListener, leave: leaveListener });
    });
  }

  public menuCollapsed = false;

  // Variables for notifications
  newApplicantsCount = 10; // Will store how many new applicants arrived
  newMatchesCount = 10; // Will store how many new applicants arrived
  showNewApplicantsToast = true; // Controls if the popup/toast is shown
  lastApplicantsCount = 0; // Keep track of old count to compare
  showGlobalBar = false; // Boolean to show the global bar
  newTutorials = false; // Boolean to indicate new tutorials
  newIntegrations = false; // Boolean to indicate new integrations
  selfserviceRecruiting = false; // Boolean to indicate self-service recruiting
  applicantsViewed = false; // Flag to track if user has viewed applicants
  fallbackUrl: string = '';
  public loading: HTMLIonLoadingElement;
  private menuStateInitListener: () => void;

  constructor(
    private profileService: ProfileService,
    private tutorialService: TutorialService,
    private menuCtrl: MenuController,
    private platform: Platform,
    private router: Router,
    private renderer: Renderer2,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private firebaseService: FirebaseService,
    private el: ElementRef,
    private menuService: MenuService,
    private themeService: ThemeService,
    private customerDB: CustomerdatabaseService,
    private userJourneyAnalytics: UserJourneyAnalyticsService,
    private alertController: AlertController,
    private loadingCtrl: LoadingController,
    private creditMonitor: CreditMonitorService,
    private toastController: ToastController,
    private translateService: TranslateService,
    private onboardingService: OnboardingService,
    private modalCtrl: ModalController,
    private arsService: ArsService,
    private workspaceTabService: WorkspaceTabService,
    private shortlistService: ShortlistService,
    private platformTour: PlatformTourService,
    private ngZone: NgZone,
  ) {
    this.translationObject = TranslationObject.TRANSLATION_OBJECT;

    this.recentChats = [];
    this.recentChatsByAgent = {};
    this.expandedAgents = {};
    this.displayedChats = [];
    this.totalChatsLoaded = 0;

    setTimeout(() => this.initDeferredSubscriptions(), 0);
  }

  async restartPlatformTour(): Promise<void> {
    try {
      localStorage.removeItem('platformTourCompletedAt');
      const planLower = (this.currentPlan || '').toLowerCase();
      const isHybridCustomer = this.isHybridCustomer || planLower.includes('hybrid') || planLower.includes('ars');
      const lang: 'DE' | 'EN' = (this.translateService.currentLang || '').toLowerCase() === 'en' ? 'EN' : 'DE';

      try { this.goHome(); } catch {}
      await new Promise(resolve => setTimeout(resolve, 400));

      const everCompleted = await this.platformTour.hasEverCompletedInFirestore();
      const steps = buildPlatformTourSteps(null, isHybridCustomer, lang);
      await this.platformTour.start(steps, lang, 0, !everCompleted);
    } catch (e) {
      console.warn('[AppComponent] restartPlatformTour failed', e);
    }
  }

  _initialiseTranslation(): void {
    const currentLang = this.translateService.currentLang;
    console.log('[Translation] _initialiseTranslation called, current lang:', currentLang);
    this.translateService.get(translations).subscribe((translatedValues) => {
      const newTranslations = { ...this.translationObject };
      translations.forEach((key) => {
        newTranslations[key] = translatedValues[key] || key;
      });
      this.translationObject = newTranslations;
      console.log('[Translation] Sample translations - Kandidaten:', this.translationObject['Kandidaten'], 
        'Vertrieb:', this.translationObject['Vertrieb']);
      try {
        this.cdr.detectChanges();
      } catch (e) {}
    });
  }

  private initDeferredSubscriptions() {
    console.log('[Translation] initDeferredSubscriptions called');
    this.translateService.onLangChange.subscribe((event) => {
      console.log('[Translation] onLangChange fired, new lang:', event.lang);
      this._initialiseTranslation();
    });
    const storedLang = localStorage.getItem('platformLanguage');
    const langToUse = storedLang || 'deutsch';
    console.log('[Translation] Initial load - storedLang:', storedLang, 'using:', langToUse);
    this.translateService.use(langToUse).subscribe(() => {
      console.log('[Translation] Initial language loaded:', langToUse);
      this._initialiseTranslation();
    });
    this.menuService.menuCompanyLogo$.subscribe((logo) => {
      this.setBusinessLogo(logo);
    });
    this.menuService.sidebarToggle$.subscribe(() => {
      this.toggleIconMenu();
    });
    this.menuService.menuItems$.subscribe(async (items) => {
      this.appPages = items;
      const union = this.getUniqueByUrl([...(this.appPages || []), ...(this.menuService.getAgentsMenu() || [])]);
      const showOrgSection = this.isAgentsCustomerType || this.isEnterpriseCustomer;
      this.organizationPages = showOrgSection
        ? (union || []).filter((i: any) => i && this.organizationMenuTitles.includes(i.title))
        : [];
        console.log('Organization Pages:', this.organizationPages);
      this.platformPages = showOrgSection
        ? (this.appPages || []).filter((i: any) => i && !this.organizationMenuTitles.includes(i.title))
        : [...(this.appPages || [])];
        console.log('Platform Pages:', this.platformPages);
      this.checkIfSalesAccount();
      this.checkIfAgentsCustomer();
      this.checkIfMonaAdminAccount();
      this.updateWorkforcePages();
        
      const currentUserId = this.authService.returnUserId();
      if (currentUserId === this.UPDATE_MESSAGES_ADMIN_UID) {
        this.isUpdateMessagesAdmin = true;
        console.log('User is update messages admin');
      }

      this.currentUserEmail = this.authService.returnUser();
      console.log(this.currentUserEmail);

      // Check if current user is info@mona user for admin onboarding access
      if (this.currentUserEmail === 'info@mona-ai.de') {
        this.isInfoMonaUser = true;
        console.log('User is info@mona - admin onboarding access granted');
      }

    });
    try {
      this.menuService.quickWinsGuide$.subscribe(async (payload: { title: string; message: string }) => {
        const steps: any[] = [
          {
            attachTo: 'body',
            title: payload.title,
            content: payload.message,
            // avatar intentionally omitted to avoid missing image glitches
            buttonText: 'Ok',
            routeAction: '',
            resources: [],
            customerType: 'all',
            placement: 'bottom'
          }
        ];
        try {
          await this.onboardingService.startWalkthrough(steps as any, 'all');
        } catch (e) {
          // Fallback to alert if popover fails
          const alert = await this.alertController.create({
            header: payload.title,
            message: payload.message,
            cssClass: 'custom-alert',
            buttons: [{ text: this.translationObject['Ok'] || 'Ok', role: 'confirm' }]
          });
          await alert.present();
        }
      });
    } catch { }
    try {
      this.menuService.organizationPopup$.subscribe(async (payload: { route: string; title: string; message: string }) => {
        const steps: any[] = [
          {
            attachTo: 'body',
            title: `${payload.title} – Upgrade erforderlich`,
            content: `${payload.message}`,
            buttonText: 'Zu den Preisen',
            routeAction: '/pricing',
            resources: [],
            customerType: 'agents-free',
            placement: 'bottom'
          }
        ];
        try {
          await this.onboardingService.startWalkthrough(steps as any, this.currentPlan || 'all');
        } catch (e) {
          const planLower = (this.currentPlan || '').toLowerCase();
          const isFree = planLower === 'agents-free' || planLower === '';

          if (isFree) {
            const alert = await this.alertController.create({
              header: `${payload.title} – Upgrade erforderlich`,
              message: `${payload.message}`,
              cssClass: 'organization-upgrade-alert',
              buttons: [
                {
                  text: 'Mehr erfahren',
                  handler: () => {
                    this.router.navigateByUrl('/pricing');
                  }
                },
                {
                  text: 'Später',
                  role: 'cancel'
                }
              ]
            });
            await alert.present();
          }
        }
      });
    } catch { }
    // Add protection against rapid subscription updates
    let lastPlanUpdate = '';
    let updateCount = 0;
    const resetUpdateCount = () => {
      setTimeout(() => { updateCount = 0; }, 1000);
    };

    this.menuService.userRole$.subscribe((plan) => {
      // Safety check: Prevent processing identical updates rapidly
      if (lastPlanUpdate === plan && updateCount > 3) {
        console.warn('[AppComponent] Ignoring rapid duplicate plan updates:', plan);
        return;
      }
      this.currentPlan = plan || '';
      console.log('currentPlan', this.currentPlan);

      if (lastPlanUpdate === plan) {
        updateCount++;
      } else {
        updateCount = 0;
        // Plan has changed - reset credit warnings for the old plan
        if (lastPlanUpdate && lastPlanUpdate !== plan) {
          this.resetCreditWarningThresholds(lastPlanUpdate);
        }
        lastPlanUpdate = plan;
      }

      // Reset counter periodically
      if (updateCount === 0) {
        resetUpdateCount();
      }

      // Don't load global bar on pricing page
      if (!this.router.url.includes('/pricing')) {
        this.loadGlobalBar();
      }
      console.log('currentPlan', this.currentPlan);
      // Reset flags first
      this.isEnterpriseCustomer = false;
      this.isAgentsCustomerType = false;
      this.isHybridCustomer = false;
      this.isArsCustomerType = false;
      this.isSelfServiceCustomerType = false;
      this.isFreeAndAgentsCustomerType = false;
      const planLower = (this.currentPlan || '').toLowerCase();
      this.isArsCustomerType = planLower.includes('hybrid') || planLower.includes('ars');

      if (this.currentPlan === "agents-free") {
        this.isFreeAndAgentsCustomerType = true;
        console.log('Setting isFreeAndAgentsCustomerType to true for plan:', this.currentPlan);
      }
      if (
        this.currentPlan == 'agents-free' ||
        this.currentPlan == 'starter' ||
        this.currentPlan == 'wachstum'
      ) {
        // Don't load global bar on pricing page
        if (!this.router.url.includes('/pricing')) {
          this.loadGlobalBar();
        }
      }
      if (this.currentPlan.includes('self-service')) {
        this.selfserviceRecruiting = true;
        this.menuService.setMenuForRole('self-service-recruiting');
        this.monaWorkforce = true;
        this.monaAutomations = false;
        this.monaSupport = false;
        this.isSelfServiceCustomerType = true;
      }
      // Hybrid customer type
      if (this.currentPlan && this.currentPlan.includes('hybrid')) {
        this.isHybridCustomer = true;
        this.menuService.setMenuForRole('hybrid');
        this.monaWorkforce = false;
        this.monaAutomations = false;
        this.monaSupport = false;
        this.loadHybridSearches();
        this.loadHybridContacts();
        this.loadHybridMonaApps();
        this.loadHybridShortlist();
      }

      // Agents customer type – skip if plan is recruiting self-service (e.g. recruiting-and-sales-25-self-service)
      const isRecruitingSelfService = this.currentPlan && this.currentPlan.includes('self-service') && (this.currentPlan.includes('recruiting') || this.currentPlan.includes('recruitingAndsales'));
      if (!this.isHybridCustomer && !isRecruitingSelfService && (this.customerDB.getIsAgentsCustomer() || (this.currentPlan && this.currentPlan.includes('agents')))) {
        if (this.currentPlan === 'agents-free') {
          this.menuService.setMenuForRole('agents-free');
          this.isFreeAndAgentsCustomerType = true;
          this.monaWorkforce = true;
        } else if (this.currentPlan.includes('agents-enterprise') || this.currentPlan.includes('enterprise')) {
          const canAccessHybrid = this.customerDB.canAccessHybridFeatures();
          if (canAccessHybrid) {
            this.menuService.setMenuForRole('agents-enterprise-hybrid');
          } else {
            this.menuService.setMenuForRole('agents-enterprise');
          }
          this.monaWorkforce = true;
        } else if (this.currentPlan.includes('ultra')) {
          this.menuService.setMenuForRole('agents-ultra');
          this.monaWorkforce = true;
        } else if (this.currentPlan.includes('pro') || this.currentPlan.includes('paid') || this.currentPlan.includes('starter')) {
          this.menuService.setMenuForRole('agents-pro');
          this.monaWorkforce = true;
        } else {
          this.menuService.setMenuForRole('agents');
        }
        this.monaWorkforce = true;
        this.monaAutomations = false;
        this.monaSupport = false;
        this.isAgentsCustomerType = true;
        this.showIntegrationsInMenu = true;
        console.log("#####################isAgentsCustomerType", this.isAgentsCustomerType);

      }
      if (this.currentPlan === 'enterprise') {
        this.isEnterpriseCustomer = true;
      }
      this.updateWorkforcePages();

      if ((this.isAgentsCustomerType || this.isEnterpriseCustomer) && this.customerDB.isDBConnected()) {
        this.loadRecentChats();
      }
    });
    this.customerDB.isAuthenticatedOnCustDb$.subscribe(isAuth => {
      if (isAuth && (this.isAgentsCustomerType || this.isEnterpriseCustomer)) {
        this.loadRecentChats();
      }
    });
    this.menuService.planLimits$.subscribe((plan) => {
      this.applicantsRemaining = plan.applicantsRemaining || 0;
      if (
        this.applicantsRemaining != undefined &&
        this.applicantsRemaining > 0
      ) {
        // Don't load global bar on pricing page
        if (!this.router.url.includes('/pricing')) {
          this.loadGlobalBar();
        }
      } else {
      }
      if (plan.planName == 'agents') {
        // Don't load global bar on pricing page
        if (!this.router.url.includes('/pricing')) {
          this.loadGlobalBar();
        }
      }
    });
  }

  private updateWorkforcePages() {
    try {
      console.log("this.isAgentsCustomerType", this.isAgentsCustomerType);
      console.log("this.isEnterpriseCustomer", this.isEnterpriseCustomer);
      console.log("this.organizationMenuTitles", this.organizationMenuTitles);

      let base = [] as any[];
      if (this.isAgentsCustomerType) {
        base = this.appPages || [];
      } else if (this.isEnterpriseCustomer) {
        base = this.menuService.getAgentsEnterpriseMenu() || [];
      } else {
        base = [];
      }
      console.log("base", base);
      // Get URLs that are already in platformPages to avoid duplicates
      const platformUrls = new Set((this.platformPages || []).map((p: any) => p?.url).filter(Boolean));
      console.log("platformUrls", platformUrls);
      // Exclude organization items AND items already in platformPages from workforce list
      this.workforcePages = (base || []).filter((i: any) => {
        if (!i) return false;
        // Exclude organization items
        if (this.organizationMenuTitles.includes(i.title)) return false;
        // Exclude items already in platformPages (to prevent duplicate selection)
        if (!this.isAgentsCustomerType) {
          if (platformUrls.has(i.url)) return false;
        }
        return true;
      });
      console.log("workforcePages", this.workforcePages);
    } catch {
      this.workforcePages = [];
    }
  }

  async loadGlobalBar() {
    this.updateGlobalBarVisibility(this.router.url);
    if (!this.isAuthenticated) {
      return;
    }
    console.log('loadGlobalBar - isFreeAndAgentsCustomerType:', this.isFreeAndAgentsCustomerType);
    await this.creditsRefresh();
    await this.getBusinessName();
  }

  private onQuickWinsUpdated = () => {
    try {
      const stored = localStorage.getItem('quickWinsPercent');
      const next = stored ? parseInt(stored, 10) || 0 : 0;
      if (next !== this.quickWinsPercent) {
        this.quickWinsPercent = next;
        this.cdr.detectChanges();
      }
    } catch { }
  }

  async gotoTopUp() {
    const alert = await this.alertController.create({
      header: 'Top‑up Credits',
      message: 'Wähle den Betrag aus',
      buttons: [
        {
          text: '€20',
          handler: () => this.startTopUp('price_1RwL4eFrMBtw8WvftihDPDKz')
        },
        {
          text: '€50',
          handler: () => this.startTopUp('price_1RwL5FFrMBtw8WvfioYmd69h')
        },
        {
          text: '€100',
          handler: () => this.startTopUp('price_1RwL5FFrMBtw8WvfBhh1d2x3')
        },
        {
          text: 'Abbrechen',
          role: 'cancel'
        }
      ]
    });
    await alert.present();
  }

  async startTopUp(productPriceId: string) {
    try {
      this.loading = await this.loadingCtrl.create({
        message: 'Processing...'
      });
      await this.loading.present();

      const userId = this.authService.returnUserId();
      let isEnterprise = false;
      if (this.customerDB.returnCurrentPlan() == 'enterprise') {
        isEnterprise = true;
      }

      const session = await this.firebaseService.createCheckoutSessionSubscription(
        userId,
        productPriceId,
        1,
        'payment',
        isEnterprise
      );

      const unsubscribe = session.onSnapshot(async (snap) => {
        const data = snap.data();
        const routeUrl = data?.url;
        if (routeUrl) {
          this.fallbackUrl = routeUrl;
          window.open(routeUrl, '_blank');
          try { await this.loading.dismiss(); } catch { }
          await this.presentAlertWithLink();
          unsubscribe();
        }
        // Check if payment was successful
        if (data?.paymentStatus === 'paid' || data?.status === 'complete') {
          // Reset credit warning thresholds after successful top-up
          this.resetCreditWarningThresholds();
        }
      }, async () => {
        try { await this.loading.dismiss(); } catch { }
      });
    } catch {
      try { await this.loading.dismiss(); } catch { }
    }
  }

  async presentAlertWithLink() {
    const alert = await this.alertController.create({
      header: 'Stripe Checkout',
      message: `<p>Die Stripe‑Checkout Seite wurde nicht automatisch geöffnet.</p><p>Bitte klicke unten, um fortzufahren.</p>`,
      buttons: [
        {
          text: 'Checkout öffnen',
          handler: () => {
            window.open(this.fallbackUrl, '_blank');
          }
        },
        {
          text: 'Schließen',
          role: 'cancel'
        }
      ]
    });
    await alert.present();
  }

  private updateGlobalBarVisibility(currentUrl?: string) {
    const url = currentUrl || this.router.url || '';
    const onHiddenRoutes = url.includes('/login') || url.includes('/signup') || url.includes('/pricing') || url.includes('/user-onboarding') || url.includes('/enterprise-sales') || url.includes('/onboarding-agent') || url.includes('/flow-preview') || url.includes('/embed');
    const shouldShow = this.isAuthenticated && !onHiddenRoutes;
    this.showGlobalBar = shouldShow;
    console.log('updateGlobalBarVisibility - showGlobalBar:', this.showGlobalBar, 'isFreeAndAgentsCustomerType:', this.isFreeAndAgentsCustomerType);
    if (this.outlet) {
      const margin = shouldShow ? '0px' : '0px';
      this.renderer.setStyle(this.outlet.nativeElement, 'margin-top', margin);
    }
  }

  private updateMenuVisibility(currentUrl?: string) {
    const url = currentUrl || this.router.url || '';
    if (isArsEmbedContext() || url.includes('/embed')) {
      this.isEmbedRoute = true;
      this.hideMenu = true;
      const ionApp = document.querySelector('ion-app');
      if (ionApp) ionApp.classList.remove('menu-force-visible');
      this.menuCtrl.enable(false, 'main-menu');
      const routerOutlet = document.querySelector('ion-router-outlet');
      if (routerOutlet) {
        (routerOutlet as HTMLElement).style.cssText += '; width: 100% !important; margin-left: 0 !important; margin-top: 0 !important;';
      }
      return;
    }
    const isAgentDashboard = url.includes('/agent-dashboard');
    this.isEmbedRoute = false;
    const shouldHide =
      url.includes('/login') ||
      url.includes('/signup') ||
      url.includes('/pricing') ||
      url.includes('/emailverify') ||
      url.includes('/account-confirmation') || 
      url.includes('/account-confirmation') ||
      url.includes('/waitlist-confirm') ||
      url.includes('/user-onboarding') ||
      url.includes('/enterprise-sales') ||
      url.includes('/onboarding-agent') ||
      url.includes('/flow-preview') ||
      this.isEmbedRoute;

    this.hideMenu = shouldHide && !isAgentDashboard;

    const ionApp = document.querySelector('ion-app');
    if (isAgentDashboard) {
      if (ionApp) ionApp.classList.add('menu-force-visible');
      this.menuCtrl.enable(true, 'main-menu');
    } else {
      if (ionApp) ionApp.classList.remove('menu-force-visible');
      if (shouldHide) {
        this.menuCtrl.enable(false, 'main-menu');
      } else {
        this.menuCtrl.enable(true, 'main-menu');
      }
    }

    const routerOutlet = document.querySelector('ion-router-outlet');
    const topMargin = this.showGlobalBar ? '0px' : '0px';
    if (routerOutlet) {
      if (this.hideMenu) {
        (routerOutlet as HTMLElement).style.cssText += `; width: 100% !important; margin-left: 0 !important; margin-top: ${topMargin} !important;`;
      } else {
        const menuWidth = this.iconsOnly ? 64 : 245;
        (routerOutlet as HTMLElement).style.cssText += `; width: calc(100%) !important; margin-top: ${topMargin} !important;`;
      }
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    // Ignore synthetic resize events (applyMenuState dispatches them) so we
    // don't loop; only react when the actual width changes.
    const width = typeof window !== 'undefined' ? window.innerWidth : 0;
    if (width === this.lastWindowWidth) {
      return;
    }
    this.lastWindowWidth = width;
    clearTimeout(this.windowResizeDebounce);
    this.windowResizeDebounce = setTimeout(() => {
      this.applyMenuState();
    }, 150);
  }

  toggleIconMenu() {
    this.iconsOnly = !this.iconsOnly;

    // Save the state to localStorage
    localStorage.setItem('menuIconsOnly', this.iconsOnly.toString());

    // Apply the state
    this.applyMenuState();

    // Ensure tooltips work after toggling
    setTimeout(() => {
      this.ensureTooltipsWork();
    }, 100);
  }

  // Menu resize drag handlers
  onMenuResizeStart(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    this.isDraggingMenuResize = true;
    
    // Get starting X position
    if (event instanceof MouseEvent) {
      this.menuResizeStartX = event.clientX;
    } else if (event instanceof TouchEvent && event.touches.length > 0) {
      this.menuResizeStartX = event.touches[0].clientX;
    }
    
    // Add global event listeners outside Angular's zone so plain mouse movement
    // does not trigger a change-detection cycle on every move (kept the app sluggish).
    this.ngZone.runOutsideAngular(() => {
      document.addEventListener('mousemove', this.boundMenuResizeMove);
      document.addEventListener('mouseup', this.boundMenuResizeEnd);
      document.addEventListener('touchmove', this.boundMenuResizeMove);
      document.addEventListener('touchend', this.boundMenuResizeEnd);
    });
    
    // Add cursor style to body
    document.body.style.cursor = 'ew-resize';
    document.body.style.userSelect = 'none';
  }

  onMenuResizeMove(event: MouseEvent | TouchEvent) {
    if (!this.isDraggingMenuResize) return;
    
    let currentX = 0;
    if (event instanceof MouseEvent) {
      currentX = event.clientX;
    } else if (event instanceof TouchEvent && event.touches.length > 0) {
      currentX = event.touches[0].clientX;
    }
    
    // Check if cursor is less than 100px from left edge (collapse menu)
    if (currentX < 120 && !this.iconsOnly) {
      // Auto-trigger toggleIconMenu when dragging left to collapse.
      // Re-enter Angular's zone because the listener runs outside of it.
      this.ngZone.run(() => {
        this.toggleIconMenu();
        this.onMenuResizeEnd(event);
      });
    }
    
    // Check if cursor is more than 120px from left edge (expand menu)
    if (currentX > 120 && this.iconsOnly) {
      // Auto-trigger toggleIconMenu when dragging right to expand.
      this.ngZone.run(() => {
        this.toggleIconMenu();
        this.onMenuResizeEnd(event);
      });
    }
  }

  onMenuResizeEnd(event: MouseEvent | TouchEvent) {
    if (!this.isDraggingMenuResize) return;
    
    this.isDraggingMenuResize = false;
    
    // Remove global event listeners using the same bound references added above.
    document.removeEventListener('mousemove', this.boundMenuResizeMove);
    document.removeEventListener('mouseup', this.boundMenuResizeEnd);
    document.removeEventListener('touchmove', this.boundMenuResizeMove);
    document.removeEventListener('touchend', this.boundMenuResizeEnd);
    
    // Restore cursor
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  }

  // Add mouse tracking for tooltips

  ensureTooltipsWork() {
    if (this.iconsOnly) {
      // Get all menu items
      const menuItems = document.querySelectorAll('.menu-item');
      const menuTitles = document.querySelectorAll('.menu-title');

      // Process menu items
      menuItems.forEach(item => {
        const label = item.querySelector('.responsive-label');
        if (label && !item.hasAttribute('data-tooltip')) {
          // Get text content and trim whitespace
          const labelText = label.textContent?.trim();
          if (labelText) {
            item.setAttribute('data-tooltip', labelText);
          }
        }
      });

      // Process menu titles
      menuTitles.forEach(title => {
        const label = title.querySelector('.menu-label');
        if (label && !title.hasAttribute('data-tooltip')) {
          // Get text content and trim whitespace
          const labelText = label.textContent?.trim();
          if (labelText) {
            title.setAttribute('data-tooltip', labelText);
          }
        }
      });

      // Make sure ion-menu and ion-content have overflow visible
      const menu = document.querySelector('ion-menu');
      const content = document.querySelector('ion-menu ion-content');

      if (menu) {
        menu.setAttribute('style', menu.getAttribute('style') + '; overflow: visible !important');
      }

      if (content) {
        content.setAttribute('style', content.getAttribute('style') + '; overflow: visible !important');
      }
      
      // Initialize real DOM tooltips
      this.initializeMenuTooltips();
    }
  }

  loadMenuState() {
    const savedState = localStorage.getItem('menuIconsOnly');
    if (savedState) {
      this.iconsOnly = savedState === 'true';
    }
    // Apply the state
    this.applyMenuState();
  }

  applyMenuState() {
    // First get direct references to all menu elements
    const menu = document.querySelector('ion-menu');
    const splitPane = document.querySelector('ion-split-pane');
    const routerOutlet = document.querySelector('ion-router-outlet');
    const ionApp = document.querySelector('ion-app');

    if (!menu || !splitPane) {
      return;
    }

    const isSmallScreen = !!window && window.innerWidth < this.MENU_HIDE_BREAKPOINT;
    this.isSmallScreen = isSmallScreen;

    if (this.hideMenu) {
      this.menuCtrl.enable(false);
      if (menu) menu.classList.remove('collapsed-menu');
      if (splitPane) splitPane.classList.remove('menu-collapsed');
      if (ionApp) ionApp.classList.remove('menu-collapsed');
      if (routerOutlet) {
        const topMargin = this.showGlobalBar ? '0px' : '0px';
        (routerOutlet as HTMLElement).style.cssText += `; width: 100% !important; margin-left: 0 !important; margin-top: ${topMargin} !important;`;
      }
      return;
    }

    this.menuCtrl.enable(true);
    this.menuService.setSidebarCollapsed(this.iconsOnly);

    // open all menus first
    this.monaWorkforce = true;
    this.monaAutomations = true;
    this.monaSupport = true;
    this.monaPlatform = true;
    this.monaSettings = true;
    if (this.iconsOnly) {
      // 1. Close the menu first to avoid transition glitches
      this.menuCtrl.close('main-menu');

      // 2. Add the collapsed-menu class
      menu.classList.add('collapsed-menu');
      splitPane.classList.add('menu-collapsed');

      if (ionApp) {
        ionApp.classList.add('menu-collapsed');
      }

      // 3. Directly set inline styles on key elements
      menu.setAttribute('style', 'width: 64px !important; max-width: 64px !important; min-width: 64px !important; overflow: visible !important;');


      // 5. Wait a brief moment and then make another pass to catch any elements
      //    that might have been changed by Ionic's internal processes
      setTimeout(() => {
        this.forceAllMenuElementWidths(64);
        this.fixContentWidths(64);
      }, 50);

      // 6. Do another pass after layout has settled
      setTimeout(() => {
        this.forceAllMenuElementWidths(64);
        this.fixContentWidths(64);
        // Force resize event
        window.dispatchEvent(new Event('resize'));
      }, 300);
    } else {
      // 1. Remove the collapsed-menu class
      menu.classList.remove('collapsed-menu');
      splitPane.classList.remove('menu-collapsed');

      if (ionApp) {
        ionApp.classList.remove('menu-collapsed');
      }

      // 2. Reset inline styles
      menu.setAttribute('style', 'width: 245px !important; max-width: 245px !important; min-width: 245px !important;');

      // 4. Follow-up to catch any elements changed by Ionic
      setTimeout(() => {
        this.forceAllMenuElementWidths(245);
        this.fixContentWidths(245);
      }, 50);

      // 5. Do another pass after layout has settled
      setTimeout(() => {
        this.forceAllMenuElementWidths(245);
        this.fixContentWidths(245);
        // Force resize event
        window.dispatchEvent(new Event('resize'));
      }, 300);
    }
  }

  // menu visibility now handled purely via CSS media queries

  forceAllMenuElementWidths(width: number) {
    // Target all possible menu-related elements
    const selectors = [
      'ion-menu',
      'ion-menu-inner',
      '.menu-inner',
      '.split-pane-side',
      '.menu-content'
    ];

    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        (el as HTMLElement).style.width = `${width}px`;
        (el as HTMLElement).style.maxWidth = `${width}px`;
        (el as HTMLElement).style.minWidth = `${width}px`;

        // Set important flag by using cssText
        (el as HTMLElement).style.cssText += `; width: ${width}px !important; max-width: ${width}px !important; min-width: ${width}px !important;`;

        // Add overflow visible for tooltips when collapsed
        if (width === 64) {
          (el as HTMLElement).style.cssText += '; overflow: visible !important;';
        }
      });
    });
  }

  fixContentWidths(menuWidth: number) {
    // Update the router outlet
    const routerOutlet = document.querySelector('ion-router-outlet');
    if (routerOutlet) {
      const topMargin = this.showGlobalBar ? '0px' : '0px';
      (routerOutlet as HTMLElement).style.cssText += `; width: calc(100%) !important; margin-left: ${menuWidth}px !important; margin-top: ${topMargin} !important;`;
    }

    // Target main content containers
    const mainContentSelectors = [
      '.split-pane-main',
      '.ion-page',
      '.ion-page > div'
    ];

    const panelExcludeSelectors = ['.setting-panel-container', '.tool-panel-container', '.setting-panel-overlay', '.tool-panel-overlay'];

    mainContentSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        if (panelExcludeSelectors.some(s => el.matches(s))) return;
        (el as HTMLElement).style.cssText += '; width: 100% !important; max-width: 100% !important; margin-left: 0 !important; left: 0 !important;';
      });
    });

    const contentElements = document.querySelectorAll('ion-router-outlet [style*="width"]');
    contentElements.forEach(el => {
      if (panelExcludeSelectors.some(s => el.matches(s))) return;
      if (!(el as HTMLElement).style.cssText.includes('100%')) {
        (el as HTMLElement).style.maxWidth = '100%';
      }
    });
  }

  checkIfAgentsCustomer() {
    if (this.customerDB.getIsAgentsCustomer()) {
      // only show the agents dashboard
    }
  }



  // Agent pricing is MONA-internal. The menu entry only appears for staff domains; the page
  // itself re-checks the same rule before it will show cost or allow an edit.
  checkIfMonaAdminAccount() {
    // This runs inside a menuItems subscription, so it must not emit unless something actually
    // changes: addMenuItem already no-ops on duplicates, but removeMenuItemByUrl always emits.
    if (!isMonaAdminEmail(this.authService.returnUser())) {
      if (this.menuService.hasMenuItemWithUrl(AGENT_PRICING_ROUTE)) {
        this.menuService.removeMenuItemByUrl(AGENT_PRICING_ROUTE);
      }
      return;
    }
    this.menuService.addMenuItem({
      title: 'Agent Pricing',
      url: AGENT_PRICING_ROUTE,
      icon: 'cash'
    });
  }

  checkIfSalesAccount() {
    const url = window.location.href || '';
    const isDevHost = url.includes('staging-mona') || url.includes('localhost');
    if (!isDevHost) return;

    const plan = this.currentPlan || this.customerDB.returnCurrentPlan() || '';
    const isAgents = this.customerDB.getIsAgentsCustomer() || (plan && plan.includes('agents'));
    const isSelfService = plan && plan.includes('self-service');
    const isHybrid = plan && plan.includes('hybrid');
    if (isAgents || isSelfService || isHybrid) return;

    const alreadyExists = (this.appPages || []).some((i: any) => i && i.url === '/contact-form');
    if (alreadyExists) return;

    this.menuService.addMenuItem({
      title: this.translationObject['Einzelkontaktierung'],
      url: '/contact-form',
      icon: 'calendar'
    });
  }

  async logout() {
    // Track logout event
    this.userJourneyAnalytics.trackLogout();

    try {
      document.cookie = `MONAPlatformToken=; path=/; max-age=0; Secure; SameSite=Strict`;
    } catch (err) { }
    localStorage.clear();
    this.customerDB.resetUserStorage();
    await this.authService.logOut();
    await this.customerDB.logOutFromCustDb();
  }

  goToProfile() {
    this.router.navigateByUrl('/profile');
  }

  goToSettings() {
    this.router.navigateByUrl('/settings');
  }

  goToPricing() {
    this.router.navigateByUrl('/pricing');
  }

  goToInvite() {
    this.router.navigateByUrl('/invite');
  }

  private checkForNewMatches() {
    // this.tutorialService.getNewMatches().then((newMatches) => {
    //   this.newMatchesCount = newMatches;
    // });
    if (this.businessName == '') {
      return;
    }

    const milliseconds =
      this.lastLogin.seconds * 1000 + this.lastLogin.nanoseconds / 1000000;
    const queryDate = new Date(milliseconds);
    if (false) {
      this.firebaseService
        .returnSalesEmailsNormalCustomers(this.businessName)
        .get()
        .then((snap) => {
          const matches = snap.docs.map((doc) => {
            const data = doc.data();
            data.id = doc.id;
            return data;
          });
          console.log(matches);
          const newMatches = [];
          this.firebaseService.saveEmailsToBeSentLocally(matches);
          matches.forEach((match) => {
            if (match.created) {
              const created = new Date(match.created);
              if (created > queryDate) {
                newMatches.push(match);
              }
            }
          });
          this.newMatchesCount = newMatches.length;
          if (this.newMatchesCount > 0) {
            this.appPages.forEach((element) => {
              if (element.title == 'Kommunikation') {
                element.showNewBadge = true;
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  private async listenToApplicants() {
    // get the date from last login
    // then get applicants with date "created" after last login
    // then set the newApplicantsCount
    const lastLogin = await this.firebaseService.returnLastLogin();
    console.log('lastLogin', lastLogin);
    const loginData = lastLogin.data().lastLogin;
    if (loginData == undefined || loginData == null) {
      this.firebaseService.updateLastLogin(this.authService.returnUserId());
      return;
    }
    console.log('lastLogin', loginData);
    const milliseconds =
      loginData.seconds * 1000 + loginData.nanoseconds / 1000000;
    const queryDate = new Date(milliseconds);
    console.log('queryDate', queryDate);
    this.customerDB
      .getApplicantsAfterDate(queryDate)
      .get()
      .then((snap) => {
        const applicants = snap.docs.map((doc) => doc.data());
        this.newApplicantsCount = applicants.length;
        this.firebaseService.updateLastLogin(this.authService.returnUserId());
        console.log('newApplicantsCount', this.newApplicantsCount);
        if (this.newApplicantsCount > 0) {
          this.appPages.forEach((element) => {
            if (element.title == 'Kandidaten') {
              element.showNewBadge = true;
            }
          });
        }
      });
  }

  private checkForNewTutorials() {
    // this.tutorialService.getNewTutorials().then((newTutorials) => {
    //   this.newTutorials = newTutorials;
    // });
  }

  private checkForNewIntegrations() {
    // this.tutorialService.getNewIntegrations().then((newIntegrations) => {
    //   this.newIntegrations = newIntegrations;
    // });
  }

  public markApplicantsAsRead() {
    // Don't reset the badge on click
    // Instead, mark it to be reset when user actually views the page
    event.stopPropagation(); // Prevent navigation
  }

  // New method to mark applicants as viewed when navigating to candidates page
  private markApplicantsAsViewed() {
    this.applicantsViewed = true;
    this.newApplicantsCount = 0;
    this.firebaseService.updateLastLogin(this.authService.returnUserId());
    // Reset badge for Kandidaten menu item
    this.appPages.forEach(element => {
      if (element.title == 'Kandidaten') {
        element.showNewBadge = false;
      }
    });
  }

  routePricing() {
    this.router.navigateByUrl('/pricing');
  }

  public markMatchesAsRead() {
    this.firebaseService.markMatchesAsRead();
    this.newMatchesCount = 0;
  }

  creditsRefresh() {
    this.customerDB.retreiveUserCreditsAllTheTimeUpToDate((credits) => {
      const previousCredits = this.creditsRemaining;
      this.creditsRemaining = credits;
      console.log("creditsRefresh", credits, this.currentPlan);

      // Track credit usage for projection
      this.trackCreditUsage(credits);

      if (this.isHybridCustomer) return;
      if (this.currentPlan && credits !== undefined && credits >= 0) {
        if (previousCredits === undefined || credits < previousCredits) {
          this.showPopupWhenUserReachesCloseToTheLimit(credits, this.currentPlan);
        }
      }
    });
  }

  private trackCreditUsage(currentCredits: number) {
    const now = Date.now();

    // Add to history
    this.creditUsageHistory.push({ timestamp: now, credits: currentCredits });

    // Keep only last 30 days of data
    const thirtyDaysAgo = now - (30 * 24 * 60 * 60 * 1000);
    this.creditUsageHistory = this.creditUsageHistory.filter(entry => entry.timestamp > thirtyDaysAgo);

    // Store in localStorage for persistence
    try {
      localStorage.setItem('creditUsageHistory', JSON.stringify(this.creditUsageHistory));
    } catch (e) {
      console.error('Failed to save credit history:', e);
    }
  }

  private calculateProjectedLimitDate(): Date | null {
    // Load history from localStorage if needed
    if (this.creditUsageHistory.length === 0) {
      try {
        const stored = localStorage.getItem('creditUsageHistory');
        if (stored) {
          this.creditUsageHistory = JSON.parse(stored);
        }
      } catch (e) {
        console.error('Failed to load credit history:', e);
      }
    }

    // Need at least 2 data points to calculate usage rate
    if (this.creditUsageHistory.length < 2) {
      return null;
    }

    // Calculate average daily usage
    const sortedHistory = [...this.creditUsageHistory].sort((a, b) => a.timestamp - b.timestamp);
    const firstEntry = sortedHistory[0];
    const lastEntry = sortedHistory[sortedHistory.length - 1];

    const creditsUsed = firstEntry.credits - lastEntry.credits;
    const daysPassed = (lastEntry.timestamp - firstEntry.timestamp) / (1000 * 60 * 60 * 24);

    if (daysPassed < 1 || creditsUsed <= 0) {
      return null; // No meaningful usage yet
    }

    const dailyUsage = creditsUsed / daysPassed;
    const creditsRemaining = this.creditsRemaining || 0;

    if (dailyUsage <= 0) {
      return null; // No usage detected
    }

    const daysUntilEmpty = creditsRemaining / dailyUsage;
    const projectedDate = new Date(Date.now() + (daysUntilEmpty * 24 * 60 * 60 * 1000));

    return projectedDate;
  }

  showPopupWhenUserReachesCloseToTheLimit(credits: number, currentPlan: string) {
    console.log('showPopupWhenUserReachesCloseToTheLimit', credits, currentPlan);
    return
    // DISABLED FOR NOW FA 2025 10 20
    const planLimits = {
      'agents-free': { total: 10000, thresholds: [5000, 2000, 1000, 500] },
      'agents-starter': { total: 10000, thresholds: [5000, 2000, 1000, 500] },
      'starter': { total: 25000, thresholds: [12500, 5000, 2500, 1250] },
      'wachstum': { total: 50000, thresholds: [25000, 10000, 5000, 2500] },
      'agents-pro': { total: 50000, thresholds: [25000, 10000, 5000, 2500] },
      'agents-paid': { total: 50000, thresholds: [25000, 10000, 5000, 2500] },
      'pro': { total: 100000, thresholds: [50000, 20000, 10000, 5000] },
      'agents-ultra': { total: 500000, thresholds: [250000, 100000, 50000, 25000] },
      'agents-enterprise': { total: 1000000, thresholds: [500000, 200000, 100000, 50000] },
      'ultra': { total: 500000, thresholds: [250000, 100000, 50000, 25000] },
      'enterprise': { total: 1000000, thresholds: [500000, 200000, 100000, 50000] }
    };

    // Find the matching plan configuration - check for exact match first
    let planConfig = planLimits[currentPlan];

    // If no exact match, check if plan contains any of the keys
    if (!planConfig) {
      for (const [key, value] of Object.entries(planLimits)) {
        if (currentPlan.includes(key)) {
          planConfig = value;
          break;
        }
      }
    }

    // Default config if plan not found - use FREE plan limits as default
    if (!planConfig) {
      planConfig = { total: 10000, thresholds: [5000, 2000, 1000, 500] };
    }

    // Special check for agents customers with agents-free plan
    if (currentPlan === 'agents-free' && (this.isAgentsCustomerType || this.isFreeAndAgentsCustomerType)) {
      planConfig = { total: 10000, thresholds: [5000, 2000, 1000, 500] };
    }

    // Calculate percentages
    const percentageRemaining = (credits / planConfig.total) * 100;
    const percentageUsed = 100 - percentageRemaining;

    // Create unique keys for each threshold - stored permanently in localStorage
    const threshold50Key = `credits_shown_${currentPlan}_${planConfig.thresholds[0]}`;
    const threshold80Key = `credits_shown_${currentPlan}_${planConfig.thresholds[1]}`;  // 20% remaining = 80% used
    const threshold90Key = `credits_shown_${currentPlan}_${planConfig.thresholds[2]}`;  // 10% remaining = 90% used
    const threshold95Key = `credits_shown_${currentPlan}_${planConfig.thresholds[3]}`;  // 5% remaining = 95% used

    if (credits <= planConfig.thresholds[3] && !localStorage.getItem(threshold95Key)) {
      // Critical: 90-95% used (5-10% remaining)
      this.alertController.create({
        header: '🚨 Kritische Warnung',
        message: `Du hast bereits ${percentageUsed.toFixed(0)}% deiner Credits verbraucht! Nur noch ${credits} Credits verbleibend. Dein Service könnte bald unterbrochen werden.`,
        cssClass: 'credit-warning-alert',
        buttons: [
          {
            text: 'Später',
            role: 'cancel'
          },
          {
            text: 'Jetzt upgraden',
            handler: () => {
              this.router.navigateByUrl('/pricing');
            }
          },
          {
            text: 'Credits aufladen',
            handler: () => {
              this.gotoTopUp();
            }
          }
        ]
      }).then(alert => {
        alert.present();
        // Mark this threshold as shown
        localStorage.setItem(threshold95Key, 'true');
        // Auto-dismiss after 10 seconds
        setTimeout(() => {
          alert.dismiss();
        }, 10000);
      });

    } else if (credits <= planConfig.thresholds[2] && !localStorage.getItem(threshold90Key)) {
      // Warning: 90% used (10% remaining)
      this.toastController.create({
        message: `⚠️ Du hast bereits ${percentageUsed.toFixed(0)}% deiner Credits verbraucht (${credits} verbleibend). Zeit für ein Upgrade!`,
        duration: 10000, // Auto-dismiss after 10 seconds
        position: 'top',
        color: 'warning',
        cssClass: 'credit-warning-toast',
        buttons: [
          {
            text: 'Upgrade',
            handler: () => {
              this.router.navigateByUrl('/pricing');
            }
          },
          {
            icon: 'close-circle-outline',
            role: 'cancel'
          }
        ]
      }).then(toast => {
        toast.present();
        // Mark this threshold as shown
        localStorage.setItem(threshold90Key, 'true');
      });

    } else if (credits <= planConfig.thresholds[1] && !localStorage.getItem(threshold80Key)) {
      // Notice: 80% used (20% remaining)
      this.toastController.create({
        message: `Du hast ${percentageUsed.toFixed(0)}% deiner Credits verbraucht (${credits} verbleibend). Plane dein nächstes Upgrade.`,
        duration: 10000, // Auto-dismiss after 10 seconds
        position: 'top',
        color: 'warning',
        cssClass: 'credit-notice-toast',
        buttons: [
          {
            text: 'Jetzt upgraden',
            handler: () => {
              this.router.navigateByUrl('/pricing');
            }
          },
          {
            icon: 'close-circle-outline',
            role: 'cancel'
          }
        ]
      }).then(toast => {
        toast.present();
        // Mark this threshold as shown
        localStorage.setItem(threshold80Key, 'true');
      });

    } else if (credits <= planConfig.thresholds[0] && !localStorage.getItem(threshold50Key)) {
      // Notice: 50% used (50% remaining)
      this.toastController.create({
        message: `ℹ️ Du hast ${percentageUsed.toFixed(0)}% deiner Credits verbraucht (${credits} verbleibend).`,
        duration: 10000, // Auto-dismiss after 10 seconds
        position: 'top',
        color: 'primary',
        cssClass: 'credit-info-toast',
        buttons: [
          {
            text: 'Upgrade-Optionen',
            handler: () => {
              this.router.navigateByUrl('/pricing');
            }
          },
          {
            icon: 'close-circle-outline',
            role: 'cancel'
          }
        ]
      }).then(toast => {
        toast.present();
        // Mark this threshold as shown
        localStorage.setItem(threshold50Key, 'true');
      });

      // For 50% threshold, ensure upgrade button is visible for agents-free users
      if (currentPlan === 'agents-free' || this.isFreeAndAgentsCustomerType) {
        this.isFreeAndAgentsCustomerType = this.isAgentsCustomerType;
        if (!this.showGlobalBar && this.isAuthenticated) {
          const url = this.router.url || '';
          if (!url.includes('/login') && !url.includes('/pricing')) {
            this.showGlobalBar = true;
            this.updateGlobalBarVisibility();
          }
        }
      }
    }

    // Special handling for agents-free plan users - always show upgrade option when below 50%
    if (currentPlan === 'agents-free' && percentageRemaining < 50 && credits > 0) {
      // Update the UI flag to show upgrade button
      this.isFreeAndAgentsCustomerType = this.isAgentsCustomerType;

      // Ensure global bar is visible
      if (!this.showGlobalBar && this.isAuthenticated) {
        const url = this.router.url || '';
        if (!url.includes('/login') && !url.includes('/pricing')) {
          this.showGlobalBar = true;
          this.updateGlobalBarVisibility();
        }
      }
    }
  }

  // Reset credit warning thresholds when user upgrades or tops up
  resetCreditWarningThresholds(plan?: string) {
    const targetPlan = plan || this.currentPlan || 'free';

    // Remove all threshold keys for the current plan
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith(`credits_shown_${targetPlan}_`) ||
        key.startsWith(`critical_credits_warning_${targetPlan}_`) ||
        key.startsWith(`credits_warning_toast_${targetPlan}_`))) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
  }

  toggleMenu() {
    this.menuCollapsed = !this.menuCollapsed;
  }

  toggle(section: 'platform' | 'workforce' | 'automations' | 'support') {
    this.monaPlatform = section === 'platform' ? !this.monaPlatform : false;
    this.monaWorkforce = section === 'workforce' ? !this.monaWorkforce : false;
    this.monaAutomations = section === 'automations' ? !this.monaAutomations : false;
    this.monaSupport = section === 'support' ? !this.monaSupport : false;
  }

  manageSubscription() {
    this.router.navigateByUrl('/pricing');
  }

  async getBusinessName() {
    console.log('#!#!#!#!#!#!#!#!#!#!#!#!#!#!#!getBusinessName CALLED');
    this.businessName = this.customerDB.returnBusinessName();
    if (this.businessName == undefined || this.businessName == null || this.businessName == '') {
      return;
    }
    this.customerDB
      .getProfile()
      .get()
      .then((data) => {
        if (data.docs.length == 0) {
          return;
        } else {
          const profileData = data.docs[0].data();
          if (profileData.companyLogo != undefined && profileData.companyLogo != null && profileData.companyLogo != '') {
            this.setBusinessLogo(profileData.companyLogo);
          } else {
            this.businessLogo = undefined;
          }

          this.themeService.setPrimary(profileData.colorCode || '#151945');

          if (profileData.platformLanguage && profileData.platformLanguage.language) {
            const dbLang = profileData.platformLanguage.language.toLowerCase();
            const storedLang = localStorage.getItem('platformLanguage');
            if (dbLang !== storedLang) {
              localStorage.setItem('platformLanguage', dbLang);
              this.translateService.use(dbLang).subscribe(() => {
                this._initialiseTranslation();
              });
            }
          }
        }
      });
    this.businessNameOnlyFirstLetter = this.businessName.charAt(0);
    console.log(
      'businessNameOnlyFirstLetter',
      this.businessNameOnlyFirstLetter,
    );
    this.lastLogin = await this.getLastLogin();
    this.checkForNewMatches();
    this.listenToApplicants();
    this.checkForNewTutorials();
    this.checkForNewIntegrations();
  }

  private setBusinessLogo(logo: string) {
    if (!logo) {
      this.businessLogo = undefined;
      return;
    }
    if (logo.startsWith('http')) {
      this.businessLogo = logo;
    } else {
      this.businessLogo = 'data:image/jpeg;base64,' + logo;
    }
  }


  async getLastLogin() {
    const lastLogin = await this.firebaseService.returnLastLogin();
    console.log('lastLogin', lastLogin);
    const loginData = lastLogin.data().lastLogin;
    if (loginData == undefined || loginData == null) {
      await this.firebaseService.updateLastLogin(
        this.authService.returnUserId(),
      );
      this.getLastLogin();
    }
    return loginData;
  }

  openMONASupportLink() {
    window.open(
      'https://meetings-eu1.hubspot.com/nhellwig/support',
    );
  }

  async requestLiveHelp() {
    const alert = await this.alertController.create({
      header: this.translationObject['liveHilfeBeantragen'] || 'Request Live Help',
      message: this.translationObject['liveHilfeNachricht'] || 'Need help setting up your agents? Book a call or send us an email.',
      buttons: [
        {
          text: this.translationObject['callBuchen'] || 'Book a Call',
          handler: () => {
            window.open('https://meetings-eu1.hubspot.com/mona-enterprise/agents-call');
          }
        },
        {
          text: this.translationObject['emailSenden'] || 'Send Email',
          handler: () => {
            window.open('mailto:felix.adam@mona-ai.de?subject=Help with Agent Setup');
          }
        },
        {
          text: this.translationObject['abbrechen'] || 'Cancel',
          role: 'cancel'
        }
      ]
    });
    await alert.present();
  }

  openDocumentation() {
    window.open('https://docs.mona-ai.de/');
  }

  openMONAChat() {
    this.chooseSubItem('chatMonaBeta');
    this.router.navigateByUrl('/mona-agent-chat');
  }

  openAIAgents() {
    console.log('[app.component.ts] ===== openAIAgents CALLED =====');
    console.log('[app.component.ts] Navigating to: /agents');
    this.chooseSubItem('chatAgentenBeta');
    this.router.navigate(['/agents']).then(success => {
      console.log('[app.component.ts] Navigation result:', success);
      console.log('[app.component.ts] Current URL:', this.router.url);
    }).catch(error => {
      console.error('[app.component.ts] Navigation error:', error);
    });
  }

  openAgentBuilder() {
    this.chooseSubItem('agentBuilder');
    this.router.navigateByUrl('/mona-agent-builder');
  }

  openWorkflowBuilder() {
    this.chooseSubItem('workflowBuilder');
    this.router.navigateByUrl('/organigram');
  }

  dataImport() {
    this.router.navigateByUrl('/upload');
  }

  async loadHybridSearches() {
    try {
      this.arsService.getSearches().subscribe(searches => {
        this.hybridSearches = searches;
      });
      await this.arsService.loadSearches();
    } catch (e) {
      console.error('[Hybrid] Failed to load searches:', e);
    }
  }

  async loadHybridShortlist() {
    try {
      this.shortlistService.getCandidates().subscribe(candidates => {
        const prevCount = this.shortlistCount;
        this.shortlistCount = candidates.length;
        if (this.shortlistCount > 0 && prevCount === 0) {
          this.hybridContactsExpanded = true;
        }
      });
      await this.shortlistService.loadCandidates();
    } catch (e) {
      console.error('[Hybrid] Failed to load shortlist:', e);
    }
  }

  refreshShortlistCount() {
    this.shortlistService.loadCandidates();
  }

  toggleHybridSearches() {
    this.hybridSearchesExpanded = !this.hybridSearchesExpanded;
  }

  openHybridSearch(search: ArsSearch) {
    this.router.navigate(['/hybrid-dashboard'], { queryParams: { search_id: search.id } });
  }

  async loadHybridContacts() {
    try {
      if (!this.customerDB.isDBConnected()) return;
      const snap = await this.customerDB.getApplicants()
        .orderBy('created', 'desc')
        .limit(50)
        .get();
      this.hybridContacts = snap.docs.map(doc => {
        const d = doc.data();
        const vorname = d.vorname || d.firstName || '';
        const nachname = d.nachname || d.lastName || '';
        return {
          id: doc.id,
          name: [vorname, nachname].filter(Boolean).join(' ') || d.email || 'Unknown',
          jobTitle: d.jobTitle || d.jobTitleCleaned || ''
        };
      });
    } catch (e) {
      console.error('[Hybrid] Failed to load contacts:', e);
    }
  }

  async loadHybridMonaApps() {
    try {
      const apiData: any = await this.customerDB.getAPIData();
      if (apiData && apiData.monaApps && Array.isArray(apiData.monaApps)) {
        apiData.monaApps.forEach((saved: any) => {
          this.menuService.addModuleMenuItem({
            title: saved.title,
            url: saved.url,
            icon: saved.icon
          });
        });
      }
    } catch (e) {
      console.error('[Hybrid] Failed to load MONA apps:', e);
    }
  }

  toggleHybridContacts() {
    this.hybridContactsExpanded = !this.hybridContactsExpanded;
  }

  openContactPanel(contact: { id: string }) {
    this.selectedContactId = contact.id;
    this.showContactPanel = true;
  }

  closeContactPanel() {
    this.showContactPanel = false;
    this.selectedContactId = '';
  }

  private openArsView(view?: string) {
    const tabs = this.workspaceTabService.getTabsSnapshot();
    const existing = tabs.find(t => t.type === 'ars');
    if (existing) {
      this.workspaceTabService.updateTab(existing.id, {
        data: { ...existing.data, view: view || undefined }
      });
      this.workspaceTabService.setActiveTab(existing.id);
    } else {
      this.workspaceTabService.createTab('ars', view ? { view } : undefined);
    }
    this.router.navigateByUrl('/hybrid-dashboard');
  }

  openArsNewSearch() {
    if (this.isHybridCustomer && this.workspaceTabService) {
      this.workspaceTabService.createTab('ars');
    }
    this.router.navigateByUrl('/hybrid-dashboard');
  }
  openArsPastSearches() { this.openArsView('past-searches'); }
  openArsContacts() { this.openArsView('contacts'); }
  openArsAppointments() { this.openArsView('appointments'); }
  openArsInbox() { this.openArsView('inbox'); }
  openArsShortlist() { this.openArsView('shortlist'); }

  openArsSession(sessionId: string) {
    if (this.isHybridCustomer && this.workspaceTabService) {
      const existingTab = this.workspaceTabService.getTabsSnapshot().find(
        (t: any) => t.type === 'ars' && t.data?.sessionId === sessionId
      );
      if (existingTab) {
        this.workspaceTabService.setActiveTab(existingTab.id);
      } else {
        const search = this.hybridSearches.find(s => s.id === sessionId);
        const tab = this.workspaceTabService.createTab('ars', { sessionId });
        if (search?.query) {
          this.workspaceTabService.updateTab(tab.id, { title: search.query });
        }
      }
    }
    this.router.navigateByUrl('/hybrid-dashboard');
  }

  toggleSearchOptions(searchId: string, event?: MouseEvent) {
    if (this.searchOptionsOpenId === searchId) {
      this.searchOptionsOpenId = null;
    } else {
      this.searchOptionsOpenId = searchId;
      this.searchRenameId = null;
      if (event) {
        const btn = event.currentTarget as HTMLElement;
        const rect = btn.getBoundingClientRect();
        this.searchOptionsMenuTop = rect.bottom + 4;
        this.searchOptionsMenuLeft = rect.right - 140;
      }
    }
  }

  startSearchRename(search: ArsSearch) {
    this.searchRenameId = search.id;
    this.searchRenameValue = search.query;
    this.searchOptionsOpenId = null;
    setTimeout(() => {
      const input = document.querySelector('.hybrid-search-rename-input') as HTMLInputElement;
      if (input) {
        input.focus();
        input.select();
      }
    }, 50);
  }

  async confirmSearchRename(search: ArsSearch) {
    const trimmed = this.searchRenameValue.trim();
    if (!trimmed || trimmed === search.query) {
      this.cancelSearchRename();
      return;
    }
    try {
      await this.updateSearchTitle(search.id, trimmed);
      const idx = this.hybridSearches.findIndex(s => s.id === search.id);
      if (idx >= 0) {
        this.hybridSearches[idx] = { ...this.hybridSearches[idx], query: trimmed };
      }
    } catch (e) {
      console.error('[Hybrid] Failed to rename search:', e);
    }
    this.searchRenameId = null;
    this.searchRenameValue = '';
  }

  cancelSearchRename() {
    this.searchRenameId = null;
    this.searchRenameValue = '';
  }

  onSearchRenameBlur(search: ArsSearch) {
    setTimeout(() => {
      if (this.searchRenameId === search.id) {
        this.confirmSearchRename(search);
      }
    }, 150);
  }

  async deleteSearch(search: ArsSearch) {
    this.searchOptionsOpenId = null;
    const confirmed = await this.showDeleteConfirmation(search.query);
    if (!confirmed) return;
    try {
      await this.arsService.deleteSearch(search.id);
      await this.deleteSearchSession(search.id);
      this.hybridSearches = this.hybridSearches.filter(s => s.id !== search.id);
    } catch (e) {
      console.error('[Hybrid] Failed to delete search:', e);
    }
  }

  private async showDeleteConfirmation(title: string): Promise<boolean> {
    return new Promise(async (resolve) => {
      const isDE = this.translationObject['language'] === 'DE' || (this.translationObject['Loeschen'] && this.translationObject['Loeschen'] === 'Löschen');
      const cleanTitle = this.cleanChatTitle(title);
      const alert = await this.alertController.create({
        cssClass: 'mona-styled-alert',
        header: isDE ? 'Chat löschen?' : 'Delete chat?',
        message: cleanTitle
          ? (isDE ? `Möchtest du "${cleanTitle}" wirklich löschen?` : `Are you sure you want to delete "${cleanTitle}"?`)
          : (isDE ? 'Möchtest du diesen Chat wirklich löschen?' : 'Are you sure you want to delete this chat?'),
        buttons: [
          { text: isDE ? 'Abbrechen' : 'Cancel', role: 'cancel', cssClass: 'alert-btn-secondary', handler: () => resolve(false) },
          { text: isDE ? 'Löschen' : 'Delete', cssClass: 'alert-btn-danger', handler: () => resolve(true) }
        ]
      });
      await alert.present();
    });
  }

  // Chat titles can contain multi-line context blobs (e.g. dropped email context
  // like "Kontext (E-Mail):\nSubject: ...\nFrom: ..."). Collapse to a single
  // short line so the confirmation message stays clean.
  private cleanChatTitle(title: string): string {
    if (!title) return '';
    const collapsed = title.replace(/\s+/g, ' ').trim();
    const maxLength = 60;
    return collapsed.length > maxLength ? `${collapsed.slice(0, maxLength).trim()}…` : collapsed;
  }

  private async updateSearchTitle(sessionId: string, title: string) {
    const uid = this.authService.returnUserId();
    if (!uid) return;
    try {
      const backendRef = this.customerDB.getArsChatHistorySessions?.(uid)?.doc(sessionId);
      if (backendRef) {
        const snap = await backendRef.get();
        if (snap && snap.exists) {
          await backendRef.update({ title });
        }
      }
    } catch (e) {
      console.warn('[Hybrid] Failed to update backend session title:', e);
    }
    try {
      const accountRef = this.customerDB.getArsChatSession?.(sessionId);
      if (accountRef) {
        const snap = await accountRef.get();
        if (snap && snap.exists) {
          await accountRef.update({ title });
        }
      }
    } catch (e) {
      console.warn('[Hybrid] Failed to update account session title:', e);
    }
  }

  private async deleteSearchSession(sessionId: string) {
    const uid = this.authService.returnUserId();
    if (!uid) return;
    try {
      const backendRef = this.customerDB.getArsChatHistorySessions?.(uid)?.doc(sessionId);
      if (backendRef) {
        const snap = await backendRef.get();
        if (snap && snap.exists) {
          await backendRef.delete();
        }
      }
    } catch (e) {
      console.warn('[Hybrid] Failed to delete backend session:', e);
    }
    try {
      const accountRef = this.customerDB.getArsChatSession?.(sessionId);
      if (accountRef) {
        const snap = await accountRef.get();
        if (snap && snap.exists) {
          await accountRef.delete();
        }
      }
    } catch (e) {
      console.warn('[Hybrid] Failed to delete account session:', e);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClickForSearchOptions(event: MouseEvent) {
    if (this.searchOptionsOpenId) {
      const target = event.target as HTMLElement;
      if (!target.closest('.hybrid-search-options-btn') && !target.closest('.hybrid-search-options-menu')) {
        this.searchOptionsOpenId = null;
      }
    }
  }

  goHome() {
    if (this.isHybridCustomer) {
      this.workspaceTabService.setActiveTab(PINNED_HOME_ID);
      this.router.navigateByUrl('/hybrid-dashboard');
    } else if (this.currentPlan === 'enterprise' || this.isEnterpriseCustomer) {
      this.router.navigateByUrl('/dashboard');
    } else if (this.isAgentsCustomerType || this.customerDB.getIsAgentsCustomer() || (this.currentPlan && this.currentPlan.includes('agents'))) {
      this.router.navigateByUrl('/agent-dashboard');
    } else {
      this.router.navigateByUrl('/dashboard');
    }
  }

  // Bound to the topbar logo click. Always lands on /dashboard regardless
  // of customer type (use goHome() if you want the type-aware variant).
  goDashboard() {
    this.router.navigateByUrl('/dashboard');
  }

  hasMenuUrl(url: string): boolean {
    try {
      return Array.isArray(this.appPages) && this.appPages.some((i: any) => i && i.url === url);
    } catch {
      return false;
    }
  }

  blacklist() {
    this.router.navigateByUrl('/blacklist');
  }

  integrations() {
    this.newIntegrations = false;
    this.router.navigateByUrl('/integrations');
  }

  getCurrentUser() {
    const currentUser = this.authService.returnUser();
    this.currentUser = currentUser;
    if (this.currentUser != 'admin@mona-ai.de') {
      this.appPages.splice(1, 6);
    }
  }

  navigateToFeedbackUrl() {
    window.open('https://www.mona-ai.de/kontakt');
  }

  openYoutube() {
    window.open('https://www.youtube.com/channel/UCZUycJcsFxQAE52kaYi52xg');
  }

  openTutorials() {
    this.router.navigateByUrl('/video-library');
  }

  openUserHandbook() {
    this.router.navigateByUrl('/user-handbook');
    this.menuCtrl.close('main-menu');
  }

  backToDashboard() {
    this.router.navigateByUrl('/dashboard');
  }

  switchMonaPlatform() {
    // If in collapsed mode, don't expand the section
    if (this.iconsOnly) {
      // Instead, navigate to the first page in the platform section if available
      if (this.appPages.length > 0) {
        this.router.navigate([this.appPages[0].url]);
      }
      return;
    }

    // Regular behavior when not in collapsed mode
    this.monaPlatform = !this.monaPlatform;
  }

  // Toggle Workforce section
  switchMonaWorkforce() { this.monaWorkforce = !this.monaWorkforce; }

  // Toggle Organization section
  switchMonaOrganization() { this.monaOrganization = !this.monaOrganization; }

  // Updated switchMonaSupport method
  switchMonaSupport() {
    // If in collapsed mode, open tutorials
    if (this.iconsOnly) {
      this.openTutorials();
      return;
    }

    // Regular behavior when not in collapsed mode
    this.monaSupport = !this.monaSupport;
  }

  // Updated switchToMONAAutomations method
  switchToMONAAutomations() {
    // If in collapsed mode, go to integrations
    if (this.iconsOnly) {
      this.integrations();
      return;
    }

    // Regular behavior when not in collapsed mode
    this.monaAutomations = !this.monaAutomations;
  }
	
  switchMonaSystem() {
    // If in collapsed mode, don't expand the section
    if (this.iconsOnly) {
      // Instead, navigate to the first page in the platform section if available
      if (this.appPages.length > 0) {
        this.router.navigate([this.appPages[0].url]);
      }
      return;
    }

    // Regular behavior when not in collapsed mode
    this.monaSystem = !this.monaSystem;
  }

  switchMonaSettings() {
    // If in collapsed mode, don't expand the section
    if (this.iconsOnly) {
      return;
    }

    // Regular behavior when not in collapsed mode
    this.monaSettings = !this.monaSettings;
  }

  mouseenter(name: string, monaDiv: HTMLDivElement) {
    switch (name) {
      case 'MONA Platform':
        monaDiv.style.backgroundColor = '#F6F6F6';
        break;
      case 'MONA Workforce':
        monaDiv.style.backgroundColor = '#F6F6F6';
        break;
      case 'Support':
        monaDiv.style.backgroundColor = '#F6F6F6';
        break;

      default:
        break;
    }
  }

  mouseleave(name: string, monaDiv: HTMLDivElement) {
    switch (name) {
      case 'MONA Platform':
        monaDiv.style.backgroundColor = 'white';
        break;
      case 'MONA Workforce':
        monaDiv.style.backgroundColor = 'white';
        break;
      case 'Support':
        monaDiv.style.backgroundColor = 'white';
        break;

      default:
        break;
    }
  }

  appmouseenter(name: string) {
    document.getElementById(name).style.backgroundColor = '#EEEEEE';
  }

  appmouseleave(name: string) {
    if (name == this.currentItemName) {
      document.getElementById(name).style.backgroundColor = '#F6F6F6';
    } else {
      document.getElementById(name).style.backgroundColor = 'white';
    }
  }

  settingmouseenter(name: string) {
    document.getElementById(name).style.backgroundColor = '#072966';
  }

  settingmouseleave(name: string) {
    document.getElementById(name).style.backgroundColor = '#151945';
  }

  chooseSubItem(name: string) {
    this.currentItemName = name;
    // If user clicks Quick Wins in menu, route to next task directly
    if (name === 'Quick Wins') {
      const nextId = this.getNextQuickWinId();
      const route = this.mapQuickWinIdToRoute(nextId);
      if (route) {
        try { localStorage.setItem('quickWinsContext', nextId); } catch { }
        this.router.navigate([route]);
        return;
      }
    }

    // Mark applicants as viewed if navigating to Kandidaten
    if (name === 'Kandidaten') {
      this.markApplicantsAsViewed();
    }

    // this.appPages.forEach(element => {
    //   if (element.title == name) {
    //     document.getElementById(element.title).style.backgroundColor = "#EEEEEE";
    //   }
    //   else {
    //     document.getElementById(element.title).style.backgroundColor = "white";
    //   }
    // });

    // let menuEntry = this.appPages.find(element => element.title == name)
    // if (menuEntry != undefined) {
    //   menuEntry.showNewBadge = false;
    // }

    // if (name == "chatMonaBeta") {
    //   document.getElementById("chatMonaBeta").style.backgroundColor = "#EEEEEE";
    // }
    // else {
    //   document.getElementById("chatMonaBeta").style.backgroundColor = "white";
    // }

    // if (name == "chatAgentenBeta") {
    //   document.getElementById("chatAgentenBeta").style.backgroundColor = "#EEEEEE";
    // }
    // else {
    //   document.getElementById("chatAgentenBeta").style.backgroundColor = "white";
    // }

    // if (name == "Tutorials") {
    //   document.getElementById("Tutorials").style.backgroundColor = "#EEEEEE";
    // }
    // else {
    //   document.getElementById("Tutorials").style.backgroundColor = "white";
    // }
  }



  getAdditionalParam() {
    const additionalParam = window.location.search?.substring(1);
    if (!additionalParam)
      return '';
    return additionalParam;
  }

  checkFromRedirect(additionalParam) {
    if (!additionalParam)
      return;
    switch (additionalParam) {
      case 'error=login_microsoft':
        this.presentToast('ErrorLoggingInWithMicrosoft', 'danger');
        break;
      case 'error=login_google':
        this.presentToast('ErrorLoggingInWithGoogle', 'danger');
        break;
      case 'success=login_microsoft':
        this.presentToast('SuccessLoggingInWithMicrosoft', 'success');
        break;
      case 'success=login_google':
        this.presentToast('SuccessLoggingInWithGoogle', 'success');
        break;
      default:
        break;
    }
  }

  presentToast(message: string, color: 'danger' | 'success' | 'warning') {

    const profileLanguage = localStorage.getItem("platformLanguage") || 'deutsch';
    this.translateService.use(profileLanguage);
    //we use translateService as the translation for platform is not yet done in this time (instead of using await, we translate 1 more thing here).
    this.translateService.get(message).toPromise().then((translatedMessage) => {
      this.toastController.create({
        message: translatedMessage,
        duration: 120000,
        position: 'top',
        color: color,
        cssClass: 'login-failed-toast',
        buttons: [
          {
            icon: "close-circle-outline",
            role: 'cancel',
          }
        ]

      }).then((toast) => {
        toast.present();
      })
    })
  }

  private isLoadingRecentChats = false;

  async loadRecentChats() {
    // Safety guard to prevent concurrent/recursive calls
    if (this.isLoadingRecentChats) {
      console.log('[loadRecentChats] Already loading, skipping duplicate call');
      return;
    }

    this.isLoadingRecentChats = true;
    this.recentChats = [];
    this.displayedChats = [];
    this.totalChatsLoaded = 0;
    this.monariAgentNames = {};
    this.monariAgentImages = {};

    if (!this.isAgentsCustomerType && !this.isEnterpriseCustomer) {
      this.isLoadingRecentChats = false;
      this.cdr.detectChanges();
      return;
    }

    if (!this.customerDB.isDBConnected()) {
      this.isLoadingRecentChats = false;
      return;
    }

    try {
      const userId = this.authService.returnUserId();
      if (!userId) {
        this.isLoadingRecentChats = false;
        this.cdr.detectChanges();
        return;
      }

      const monariAgentsSnapshot = await this.customerDB.getMonariAgentsCollection().get();
      const agents = monariAgentsSnapshot.docs.map((doc: any) => ({ id: doc.id, ...doc.data() }));

      const allChats: any[] = [];

      for (const agent of agents) {
        try {
          const userChatsSnapshot = await this.customerDB.getMonariAgentsChatHistory(agent.id).limit(50).get();
          if (userChatsSnapshot.empty) continue;

          const agentName = agent.name || agent.title || agent.displayName || agent.id;
          this.monariAgentNames[agent.id] = agentName;
          this.monariAgentImages[agent.id] = agent.image || agent.icon || 'assets/agents/Freeagent.png';

          const agentChats = userChatsSnapshot.docs.map((chatDoc: any) => {
            const chatData = chatDoc.data();
            return {
              id: chatDoc.id,
              session_id: chatDoc.id,
              agent_id: agent.id,
              agent_name: agentName,
              agent_image: this.monariAgentImages[agent.id],
              created: chatData.created || chatData.createdISO || new Date(),
              messages: chatData.messages || [],
              caption: this.generateChatCaption(chatData.messages),
              ...chatData
            };
          });

          allChats.push(...agentChats);
        } catch { }
      }

      // Sort all chats by timestamp (newest first)
      allChats.sort((a: any, b: any) => {
        const aTime = this.getDateFromTimestamp(a.created).getTime();
        const bTime = this.getDateFromTimestamp(b.created).getTime();
        return bTime - aTime;
      });

      // Format chats and store all
      this.recentChats = allChats.map((chat: any) => ({
        ...chat,
        displayName: this.formatChatDisplayName(chat),
        timeAgo: this.getTimeAgo(chat.created)
      }));

      // Load initial 10 chats
      this.loadMoreChats();
    } catch (error) {
      console.error('[loadRecentChats] Error:', error);
    } finally {
      // Always reset the loading flag
      this.isLoadingRecentChats = false;
    }

    this.cdr.detectChanges();
  }

  private getDateFromTimestamp(timestamp: any): Date {
    if (timestamp?.toDate) {
      return timestamp.toDate();
    } else if (timestamp?.seconds) {
      return new Date(timestamp.seconds * 1000);
    } else if (typeof timestamp === 'string') {
      return new Date(timestamp);
    } else if (timestamp instanceof Date) {
      return timestamp;
    } else {
      return new Date();
    }
  }

  private generateChatCaption(messages: any[]): string {
    if (!messages || messages.length === 0) {
      return 'New Chat';
    }

    // Find the first user message (skip welcome messages from agents)
    const firstUserMessage = messages.find(msg =>
      msg.sender === 'user' ||
      msg.role === 'user' ||
      msg.type === 'user' ||
      msg.type === 'human' ||
      (msg.sender !== 'MONA' && msg.sender !== 'ai' && msg.content && !msg.content.toLowerCase().includes('hallo! ich bin'))
    );

    if (firstUserMessage) {
      const content = firstUserMessage.content || firstUserMessage.message || firstUserMessage.text || '';
      if (content && content.trim()) {
        // Clean the content from any system prompts or instructions
        const cleanContent = content.replace(/^(Please introduce yourself|Hello, please introduce|Hi)/i, '').trim();

        if (cleanContent) {
          // Split into words and take first 4 words consistently
          const words = cleanContent.trim().split(/\s+/);
          const wordCount = Math.min(words.length, 4);
          const shortCaption = words.slice(0, wordCount).join(' ');

          // Add ellipsis if there are more words
          return words.length > wordCount ? shortCaption + '...' : shortCaption;
        }
      }
    }

    // If no user message found, look for any meaningful content (excluding welcome messages)
    for (const message of messages) {
      const content = message.content || message.message || message.text || '';
      if (content && content.trim() &&
        !content.toLowerCase().includes('hallo! ich bin') &&
        !content.toLowerCase().includes('hello! i\'m') &&
        !content.toLowerCase().includes('introduce yourself')) {
        const words = content.trim().split(/\s+/);
        const wordCount = Math.min(words.length, 4);
        const shortCaption = words.slice(0, wordCount).join(' ');
        return words.length > wordCount ? shortCaption + '...' : shortCaption;
      }
    }

    return 'New Chat';
  }

  loadRecentChatsFromLocal() {
    // Always initialize the properties first
    this.recentChats = [];
    this.recentChatsByAgent = {};
    this.expandedAgents = {};

    try {
      // Try to load from localStorage as a simple fallback
      const storedChats = localStorage.getItem('recentAgentChats');
      if (storedChats) {
        const parsedChats = JSON.parse(storedChats);
        if (Array.isArray(parsedChats)) {
          this.recentChats = parsedChats;
          this.processRecentChats();
        }
      } else {
        // Initialize with empty data if no stored chats
        console.log('No recent chats data available - initializing empty state');
      }
    } catch (error) {
      console.log('Error loading recent chats from localStorage:', error);
    }

    this.cdr.detectChanges();
  }

  private processRecentChats() {
    // Group chats by agent
    this.recentChatsByAgent = {};
    this.recentChats.forEach(chat => {
      const agentId = chat.agent_id;
      const agentName = chat.agent_name;

      if (agentId && agentName) {
        if (!this.recentChatsByAgent[agentId]) {
          this.recentChatsByAgent[agentId] = [];
        }

        // Only add if we don't already have this session
        const exists = this.recentChatsByAgent[agentId].some(existingChat =>
          existingChat.session_id === chat.session_id
        );

        if (!exists) {
          this.recentChatsByAgent[agentId].push({
            ...chat,
            displayName: this.formatChatDisplayName(chat),
            timeAgo: this.getTimeAgo(chat.created)
          });
        }
      }
    });

    // Limit to 5 recent chats per agent
    Object.keys(this.recentChatsByAgent).forEach(agentId => {
      this.recentChatsByAgent[agentId] = this.recentChatsByAgent[agentId].slice(0, 5);
    });
  }

  // Method to save a chat session to localStorage when a new chat is created
  saveRecentChatToLocal(chatData: any) {
    try {
      const storedChats = localStorage.getItem('recentAgentChats');
      let chats: any[] = [];

      if (storedChats) {
        chats = JSON.parse(storedChats);
      }

      // Add new chat to the beginning
      chats.unshift({
        ...chatData,
        created: new Date().toISOString()
      });

      // Keep only the last 50 chats
      chats = chats.slice(0, 50);

      // Save back to localStorage
      localStorage.setItem('recentAgentChats', JSON.stringify(chats));

      // Reload the recent chats display
      this.loadRecentChatsFromLocal();

    } catch (error) {
      console.error('Error saving recent chat to localStorage:', error);
    }
  }

  formatChatDisplayName(chat: any): string {
    let date: Date;

    if (chat.created?.toDate) {
      // Firestore timestamp
      date = chat.created.toDate();
    } else if (typeof chat.created === 'string') {
      // ISO string from localStorage
      date = new Date(chat.created);
    } else if (chat.created) {
      // Other date format
      date = new Date(chat.created);
    } else {
      // Fallback to current date
      date = new Date();
    }

    const timeStr = date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
    return `Chat ${timeStr}`;
  }

  getTimeAgo(timestamp: any): string {
    let date: Date;

    if (timestamp?.toDate) {
      // Firestore timestamp
      date = timestamp.toDate();
    } else if (typeof timestamp === 'string') {
      // ISO string from localStorage
      date = new Date(timestamp);
    } else if (timestamp) {
      // Other date format
      date = new Date(timestamp);
    } else {
      // Fallback to current date
      return 'Gerade eben';
    }

    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);

    if (diffHours < 1) {
      return 'Gerade eben';
    } else if (diffHours < 24) {
      return `vor ${diffHours}h`;
    } else if (diffDays < 7) {
      return `vor ${diffDays}d`;
    } else {
      return date.toLocaleDateString('de-DE');
    }
  }

  loadMoreChats() {
    if (this.isLoadingMoreChats || this.totalChatsLoaded >= this.recentChats.length) {
      return;
    }

    this.isLoadingMoreChats = true;

    // Get next batch of chats
    const nextBatch = this.recentChats.slice(
      this.totalChatsLoaded,
      this.totalChatsLoaded + this.chatsPerLoad
    );

    // Add to displayed chats
    this.displayedChats.push(...nextBatch);
    this.totalChatsLoaded += nextBatch.length;

    this.isLoadingMoreChats = false;
    this.cdr.detectChanges();
  }

  onScroll(event: any) {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      // User has scrolled to bottom
      this.loadMoreChats();
    }
  }

  openChat(agentId: string, sessionId: string) {
    console.log('Opening chat for agent:', agentId, 'session:', sessionId);

    // Navigate to the main mona-agent-chat interface with agent and session parameters
    this.router.navigate(['/mona-agent-chat'], {
      queryParams: {
        agentId: agentId,
        sessionId: sessionId
      }
    });

    // Close the menu after navigation
    this.menuCtrl.close('main-menu');
  }

  getAgentName(agentId: string): string {
    const name = this.monariAgentNames[agentId];
    if (name) return name;
    const chats = this.recentChatsByAgent?.[agentId];
    return chats && chats.length > 0 ? chats[0].agent_name : 'Agent';
  }

  getAgentChatCount(agentId: string): number {
    return this.recentChatsByAgent?.[agentId]?.length || 0;
  }

  getAgentChats(agentId: string): any[] {
    return this.recentChatsByAgent?.[agentId] || [];
  }

  isAgentExpanded(agentId: string): boolean {
    return this.expandedAgents[agentId] || false;
  }

  getAgentImage(agentId: string): string {
    return this.monariAgentImages[agentId] || 'assets/agents/Freeagent.png';
  }

  toggleRecentChats() {
    this.showRecentChats = !this.showRecentChats;
  }

  // Method to refresh recent chats - can be called from other components
  refreshRecentChats() {
    if (this.isAgentsCustomerType || this.isEnterpriseCustomer) {
      // Use setTimeout to break any potential synchronous call chains
      setTimeout(() => {
        this.loadRecentChats();
      }, 0);
    }
  }

  // Helper method to get agent name from ID
  private async getAgentNameFromId(agentId: string): Promise<string> {
    try {
      // Try monari_agents collection first
      const monariAgentDoc = await this.customerDB.app2.firestore
        .collection('monari_agents')
        .doc(agentId)
        .get();

      if (monariAgentDoc.exists) {
        const agentData = monariAgentDoc.data();
        return agentData.name || agentData.title || `Agent ${agentId}`;
      }

      // Fallback to regular agents collection
      const agentDoc = await this.customerDB.getAgents().doc(agentId).get();
      if (agentDoc.exists) {
        const agentData = agentDoc.data();
        return agentData.name || agentData.title || `Agent ${agentId}`;
      }
    } catch (error) {
      // Silent fail
    }
    return `Agent ${agentId}`;
  }

  private checkUpgradeEligibility(currentUrl: string = '') {
    if (this.isHybridCustomer) return;

    const url = currentUrl || this.router.url || '';

    // Don't show upgrade prompts on certain pages
    const hideUpgradePages = [
      '/pricing',
      '/login',
      '/signup',
      '/emailverify',
      '/account-confirmation',
      '/waitlist-confirm'
    ];

    const shouldHideUpgrade = hideUpgradePages.some(page => url.includes(page));

    if (shouldHideUpgrade) {
      return;
    }

    // Check if user is eligible for upgrade
    const isEligibleForUpgrade = this.checkIfEligibleForUpgrade();

    // Update UI based on eligibility
    if (isEligibleForUpgrade && this.isAuthenticated) {
      this.showUpgradePrompts();
    }

    // Check if user is approaching limits
    if (this.isAuthenticated && this.currentPlan && this.creditsRemaining !== undefined) {
      this.checkPlanLimitsAndNotify();
    }
  }

  private checkIfEligibleForUpgrade(): boolean {
    // Enterprise users never see upgrade prompts
    if (this.currentPlan && this.currentPlan.includes('enterprise')) {
      return false;
    }

    // Agents-free plan users are always eligible for upgrade
    if (this.currentPlan === 'agents-free') {
      return true;
    }

    // Free agents customers are eligible
    if (this.isFreeAndAgentsCustomerType) {
      return true;
    }

    // Starter plan can upgrade to higher tiers
    if (this.currentPlan === 'starter' || this.currentPlan === 'agents-starter') {
      return true;
    }

    // Wachstum plan can upgrade to enterprise
    if (this.currentPlan === 'wachstum') {
      return true;
    }

    // Pro/paid users can upgrade to ultra (but not agents-ultra)
    if (this.currentPlan && this.currentPlan.includes('pro') && !this.currentPlan.includes('ultra')) {
      return true;
    }

    // Self-service can upgrade to full plans
    if (this.isSelfServiceCustomerType) {
      return true;
    }

    // Ultra users don't need upgrades
    if (this.currentPlan && this.currentPlan.includes('ultra')) {
      return false;
    }

    return false;
  }

  private showUpgradePrompts() {
    // Skip upgrade prompts for enterprise plans
    if (this.currentPlan && this.currentPlan.includes('enterprise')) {
      return;
    }

    // Ensure the global bar is visible if user needs to upgrade
    if (!this.showGlobalBar && this.isAuthenticated) {
      const url = this.router.url || '';
      if (!url.includes('/login') && !url.includes('/pricing')) {
        this.showGlobalBar = true;
        this.updateGlobalBarVisibility();
      }
    }

    if (this.creditsRemaining !== undefined && this.creditsRemaining < 100) {
      this.showLowCreditsToast();
    }
  }

  private checkPlanLimitsAndNotify() {
    const plan = this.currentPlan;
    const credits = this.creditsRemaining;

    if (!plan || credits === undefined) return;

    // Skip credit warnings for enterprise plans
    if (plan.includes('enterprise')) {
      return;
    }

    // Define credit thresholds for each plan (only show warnings for agents-free, agents-pro, agents-ultra)
    const planLimits = {
      'agents-free': { total: 10000, warning: 5000, critical: 1000 },
      'starter': { total: 25000, warning: 10000, critical: 2500 },
      'wachstum': { total: 50000, warning: 20000, critical: 5000 },
      'pro': { total: 100000, warning: 25000, critical: 10000 },
      'ultra': { total: 500000, warning: 100000, critical: 50000 },
      'agents-starter': { total: 25000, warning: 10000, critical: 2500 },
      'agents-pro': { total: 100000, warning: 25000, critical: 10000 },
      'agents-ultra': { total: 500000, warning: 100000, critical: 50000 },
    };

    // Find matching plan limits
    let limits = null;
    for (const [key, value] of Object.entries(planLimits)) {
      if (plan.includes(key)) {
        limits = value;
        break;
      }
    }

    if (!limits) {
      // Default limits for unknown plans
      limits = { total: 50000, warning: 20000, critical: 5000 };
    }

    if (credits < limits.critical) {
      this.showCriticalCreditsWarning(credits, limits.critical);
    } else if (credits < limits.warning) {
      this.showCreditsWarningToast(credits, limits.warning);
    }

    const percentage = (credits / limits.total) * 100;
    if (percentage < 10) {
      this.isFreeAndAgentsCustomerType = this.currentPlan === 'agents-free' && this.isAgentsCustomerType;
    }
  }

  private showLowCreditsToast() {
    const toastKey = 'low_credits_toast_shown';
    if (!sessionStorage.getItem(toastKey)) {
      const projectedDate = this.calculateProjectedLimitDate();
      const message = projectedDate
        ? `Du wirst voraussichtlich am ${this.formatProjectedDate(projectedDate)} dein Limit erreichen basierend auf deiner aktuellen Nutzung`
        : `Credits laufen aus (${this.creditsRemaining} verbleibend). Erwäge ein Upgrade!`;

      this.toastController.create({
        message: message,
        duration: 10000, // Auto-dismiss after 10 seconds
        position: 'top',
        color: 'warning',
        cssClass: 'low-credits-toast',
        buttons: [
          {
            text: 'Upgrade',
            handler: () => {
              this.router.navigateByUrl('/pricing');
            }
          },
          {
            text: 'Top-up',
            handler: () => {
              this.gotoTopUp();
            }
          },
          {
            icon: 'close-circle-outline',
            role: 'cancel'
          }
        ]
      }).then(toast => toast.present());
      sessionStorage.setItem(toastKey, 'true');
    }
  }

  private showCreditsWarningToast(current: number, threshold: number) {
    const warningKey = `credits_warning_toast_${this.currentPlan}_${threshold}`;

    if (localStorage.getItem(warningKey)) {
      return;
    }

    const projectedDate = this.calculateProjectedLimitDate();
    const message = projectedDate
      ? `Du wirst voraussichtlich am ${this.formatProjectedDate(projectedDate)} dein Limit erreichen basierend auf deiner aktuellen Nutzung`
      : `Du hast ${current} Credits verbleibend. Erwäge ein Upgrade bevor du das Limit erreichst.`;

    this.toastController.create({
      message: message,
      duration: 10000, // Auto-dismiss after 10 seconds
      position: 'top',
      color: 'warning',
      cssClass: 'credits-warning-toast',
      buttons: [
        {
          text: 'Jetzt upgraden',
          handler: () => {
            this.router.navigateByUrl('/pricing');
          }
        },
        {
          icon: 'close-circle-outline',
          role: 'cancel'
        }
      ]
    }).then(toast => {
      toast.present();
      localStorage.setItem(warningKey, 'true');
    });
  }

  private showCriticalCreditsWarning(current: number, threshold: number) {
    const criticalWarningKey = `critical_credits_warning_${this.currentPlan}_${threshold}`;

    if (localStorage.getItem(criticalWarningKey)) {
      return;
    }

    const projectedDate = this.calculateProjectedLimitDate();
    const message = projectedDate
      ? `Du wirst voraussichtlich am ${this.formatProjectedDate(projectedDate)} dein Limit erreichen! Dein Service könnte dann unterbrochen werden. Bitte upgrade oder lade dein Konto auf.`
      : `Du hast nur noch ${current} Credits! Dein Service könnte bald unterbrochen werden. Bitte upgrade oder lade dein Konto auf.`;

    // Show more urgent notification
    this.alertController.create({
      header: '⚠️ Niedrige Credits Warnung',
      message: message,
      cssClass: 'critical-credits-alert',
      buttons: [
        {
          text: 'Später',
          role: 'cancel'
        },
        {
          text: 'Jetzt upgraden',
          handler: () => {
            this.router.navigateByUrl('/pricing');
          }
        },
        {
          text: 'Credits aufladen',
          handler: () => {
            this.gotoTopUp();
          }
        }
      ]
    }).then(alert => {
      alert.present();
      localStorage.setItem(criticalWarningKey, 'true');
      // Auto-dismiss after 10 seconds
      setTimeout(() => {
        alert.dismiss();
      }, 10000);
    });
  }

  private formatProjectedDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    };
    return date.toLocaleDateString('de-DE', options);
  }

  getSubscriptionTierName(): string {
    if (this.currentPlan?.includes('agents-enterprise') || this.currentPlan?.includes('enterprise')) {
      return 'Enterprise';
    } else if (this.currentPlan?.includes('agents-ultra') || this.currentPlan?.includes('ultra')) {
      return 'Ultra';
    } else if (this.currentPlan?.includes('agents-pro') || this.currentPlan?.includes('pro')) {
      return 'Pro';
    }
    return '';
  }

  shouldShowSubscriptionChip(): boolean {
    return this.currentPlan &&
      (this.currentPlan.includes('agents-pro') ||
        this.currentPlan.includes('agents-ultra') ||
        this.currentPlan.includes('agents-enterprise') ||
        this.currentPlan.includes('enterprise'));
  }

  getSubscriptionChipClass(): string {
    if (this.currentPlan?.includes('agents-enterprise') || this.currentPlan?.includes('enterprise')) {
      return 'subscription-chip-enterprise';
    } else if (this.currentPlan?.includes('agents-ultra') || this.currentPlan?.includes('ultra')) {
      return 'subscription-chip-ultra';
    } else if (this.currentPlan?.includes('agents-pro') || this.currentPlan?.includes('pro')) {
      return 'subscription-chip-pro';
    }
    return '';
  }

  ngOnDestroy() {
    // Clean up event listener to prevent memory leaks
    if (this.menuStateInitListener) {
      window.removeEventListener('menuStateInit', this.menuStateInitListener);
    }
    window.removeEventListener('quickWinsUpdated', this.onQuickWinsUpdated);
    
    // Clean up tooltip listeners
    this.tooltipListeners.forEach((listeners, item) => {
      item.removeEventListener('mouseenter', listeners.enter);
      item.removeEventListener('mouseleave', listeners.leave);
    });
    this.tooltipListeners.clear();
    
    // Remove any existing tooltip
    const existingTooltip = document.getElementById('menu-tooltip');
    if (existingTooltip) existingTooltip.remove();
  }

  // Auto-open important messages on login if there are new messages
  async checkAndShowImportantMessages() {
    try {
      console.log('Checking for new important messages...');

      // Check if Firebase service is available
      if (!this.firebaseService) {
        console.log('Firebase service not available yet');
        return;
      }

      const hasNewMessages = await this.hasNewImportantMessages();
      console.log('Has new messages:', hasNewMessages);

      if (hasNewMessages) {
        console.log('Opening important messages modal automatically...');
        // Small delay to let the page load first
        setTimeout(() => {
          this.openImportantMessages(true);
        }, 1500);
      } else {
        console.log('No new messages to show - modal will not open');
      }
    } catch (error) {
      console.error('Error checking for new important messages:', error);
    }
  }

  // Check if there are new messages since last login (instance method)
  async hasNewImportantMessages(): Promise<boolean> {
    try {
      const lastSeenId = localStorage.getItem('lastSeenImportantMessage');
      console.log('Last seen message ID:', lastSeenId);

      // Try to get important messages from Firebase
      try {
        console.log('Checking for new important messages...');

        // First try with ordering by timestamp
        let messagesSnapshot;
        try {
          messagesSnapshot = await this.firebaseService.getImportantMessages()
            .orderBy('timestamp', 'desc')
            .limit(1)
            .get();
        } catch (orderError) {
          console.warn('Could not order by timestamp, trying without ordering:', orderError);
          // If ordering fails, try without ordering
          messagesSnapshot = await this.firebaseService.getImportantMessages()
            .limit(1)
            .get();
        }

        console.log('Messages snapshot empty:', messagesSnapshot.empty);
        console.log('Number of documents found:', messagesSnapshot.docs.length);

        if (!messagesSnapshot.empty) {
          const latestMessage = messagesSnapshot.docs[0];
          const data = latestMessage.data();
          console.log('Latest message ID:', latestMessage.id);
          console.log('Latest message data:', data);

          // Check if message should be displayed based on start and end time
          const startTime = data.startTime ?
            (data.startTime.toDate ? data.startTime.toDate() : new Date(data.startTime)) :
            (data.timestamp ? (data.timestamp.toDate ? data.timestamp.toDate() : new Date(data.timestamp)) : new Date());

          const endTime = data.endTime ?
            (data.endTime.toDate ? data.endTime.toDate() : new Date(data.endTime)) :
            null;

          const currentDate = new Date();

          console.log('Start time:', startTime);
          console.log('End time:', endTime);
          console.log('Current time:', currentDate);

          // Check if current time is within the display window
          const isAfterStart = currentDate >= startTime;
          const isBeforeEnd = !endTime || currentDate <= endTime;
          if (isAfterStart && isBeforeEnd) {
            const isNewMessage = !lastSeenId || latestMessage.id !== lastSeenId;
            console.log('Message is in display window, is new:', isNewMessage);
            return isNewMessage;
          } else {
            console.log('Message is outside display window, not showing');
            return false;
          }
        } else {
          console.log('No messages found in collection');
        }
      } catch (firebaseError) {
        console.error('Could not access Firebase important messages:', firebaseError);
        console.error('Error details:', firebaseError.message);
      }

      console.log('No messages to show');
      return false;
    } catch (error) {
      console.error('Error checking for new messages:', error);
      return false;
    }
  }

  async openImportantMessages(autoOpened: boolean = false) {
    const modal = await this.modalCtrl.create({
      component: ImportantMessagesModalComponent,
      componentProps: {
        autoOpened: autoOpened
      },
      cssClass: 'important-messages-modal',
      backdropDismiss: !autoOpened // Don't allow backdrop dismiss if auto-opened
    });

    await modal.present();
  }



  // Ensure default branding exists (no UI exposure)
  private async ensureBrandingProfileExists(): Promise<void> {
    console.log('[Translation] ensureBrandingProfileExists called');
    try {
      const profileCollection = this.customerDB.getProfile();
      if (!profileCollection) {
        console.log('[Translation] No profile collection found');
        return;
      }
      const snap = await profileCollection.get();
      console.log('[Translation] Profile snap - empty:', snap.empty, 'docs:', snap.docs.length);
      if (!snap.empty && snap.docs.length > 0) {
        const profileData = snap.docs[0].data();
        console.log('[Translation] Profile platformLanguage:', profileData?.platformLanguage);
        if (profileData?.platformLanguage?.language) {
          const dbLang = profileData.platformLanguage.language.toLowerCase();
          const storedLang = localStorage.getItem('platformLanguage');
          const currentLang = this.translateService.currentLang;
          console.log('[Translation] DB lang:', dbLang, 'localStorage:', storedLang, 'current:', currentLang);
          localStorage.setItem('platformLanguage', dbLang);
          console.log('[Translation] Calling translateService.use(' + dbLang + ')...');
          this.translateService.use(dbLang).subscribe(() => {
            console.log('[Translation] translateService.use() completed for:', dbLang);
            this._initialiseTranslation();
          });
        } else {
          // Profile exists but was created without a platform language (older
          // accounts / pre-checkout profiles). Backfill it from the language the
          // system detected during signup/pricing so the durable profile always
          // carries a correct language going forward.
          console.log('[Translation] No platformLanguage in profile - backfilling from localStorage');
          const resolved = resolvePlatformLanguage(localStorage.getItem('platformLanguage'));
          localStorage.setItem('platformLanguage', resolved.language);
          if (!isPartnerLaunch()) {
            try {
              await snap.docs[0].ref.update({ platformLanguage: resolved });
            } catch (e) {
              console.error('[Translation] Failed to backfill platformLanguage:', e);
            }
          }
          this.translateService.use(resolved.language).subscribe(() => {
            this._initialiseTranslation();
          });
        }
        return;
      }
      if (isPartnerLaunch()) return this.useStoredPlatformLanguage();
      const userEmail = this.authService.returnUser();
      const allowedTools = Object.values(toolInfos as any).reduce((acc: any, t: any) => {
        if (t && t.name) { acc[t.name] = true; }
        return acc;
      }, {});

      const defaultBranding = {
        firmenname: userEmail || '',
        webseite: '',
        companyLogo: '',
        colorCode: '#5c37df',
        email: userEmail || '',
        // Seed the branding language from the language the user chose during
        // signup/pricing (mirrored into platformLanguage) instead of forcing German.
        platformLanguage: resolvePlatformLanguage(localStorage.getItem('platformLanguage')),
        allowed_tools: allowedTools,
        fallbackInterviewId: '',
        interviewFinishedURL: '',
        euMatching: false,
        minimumMatchingResult: 0,
        sendMatches: false,
        chosenCriteria: [],
        mustHaves: [],
        personalizedMessage: '',
        dataProtection: '',
      };
      await this.customerDB.createProfile(defaultBranding);
    } catch (e) {
      console.error('ensureBrandingProfileExists (profile) error:', e);
      if (isPartnerLaunch()) return this.useStoredPlatformLanguage();
      setTimeout(async () => {

        console.log('Account is somehow not created. Delaying...');
        //recheck again for now. In future, we can use better event-driven approach.
        await this.ensureBrandingProfileExists();
      }, 3000);
    }
  }

  private useStoredPlatformLanguage(): void {
    const resolved = resolvePlatformLanguage(localStorage.getItem('platformLanguage'));
    this.translateService.use(resolved.language).subscribe(() => this._initialiseTranslation());
  }

  setIsAdmin() {
    if (this.customerDB.getCustomerNumber() == null) return;
    this.getPlanLimits().then((limits) => {
      console.log(limits)
      if (limits != undefined && (limits.planName == "plan3" || limits.planName == "plan4")) {
        this.adminBool = true;
      }
    });
  }

  getPlanLimits() {
    return this.firebaseService.getPlanLimitsForCompany();
  }


  setAppPages() {
    this.appPages = [
      { title: this.translationObject['Workflows'], url: '/communication-dashboard', photo: '../assets/flaticons/bullhorn.png', disabled: false },
      { title: this.translationObject['Teamverwaltung'], url: '/team-management', photo: '../assets/flaticons/manager.png', disabled: false },
      { title: this.translationObject['DatenImport'], url: '/upload', photo: '../assets/flaticons/import.png', disabled: false },
      { title: this.translationObject['Integrationen'], url: '/integrations', photo: '../assets/flaticons/integrations.png', disabled: false },
      { title: this.translationObject['Blacklist'], url: '/blacklist', photo: '../assets/flaticons/blacklist.png', disabled: false },
      // { title: 'Benutzerhandbuch', url: '/user-handbook', photo: '../assets/svg/handbook.svg', disabled: false },
      // { title: this.translationObject['DataWarehouse'], url: '/data-warehouse', photo: '../assets/flaticons/data-warehouse.png', disabled: false },
      // { title: this.translationObject['BewerberLeadgenerierung'], url: '/automations/applicant-email', photo: '../assets/flaticons/automation-applicants.png', disabled: true },
      // { title: this.translationObject['KundenLeadgenerierung'], url: '/matching', photo: '../assets/flaticons/customer_lead.png', disabled: false },
    ];

    this.appPages2 = [
      { title: this.translationObject['Workflows'], url: '/communication-dashboard', photo: '../assets/flaticons/bullhorn.png', disabled: false },
      { title: this.translationObject['Teamverwaltung'], url: '/team-management', photo: '../assets/flaticons/manager.png', disabled: false },
      { title: this.translationObject['DatenImport'], url: '/upload', photo: '../assets/flaticons/import.png', disabled: false },
      { title: this.translationObject['Integrationen'], url: '/integrations', photo: '../assets/flaticons/integrations.png', disabled: false },
      { title: this.translationObject['Blacklist'], url: '/blacklist', photo: '../assets/flaticons/blacklist.png', disabled: false },
      // { title: 'Benutzerhandbuch', url: '/user-handbook', photo: '../assets/svg/handbook.svg', disabled: false },
      // { title: this.translationObject['DataWarehouse'], url: '/data-warehouse', photo: '../assets/flaticons/data-warehouse.png', disabled: false },
      // { title: this.translationObject['BewerberLeadgenerierung'], url: '/automations/applicant-email', photo: '../assets/flaticons/automation-applicants.png', disabled: true },
      // { title: this.translationObject['KundenLeadgenerierung'], url: '/matching', photo: '../assets/flaticons/customer_lead.png', disabled: false },
    ];

    // Add Update Messages admin tab only for specific user
    if (this.isUpdateMessagesAdmin) {
      this.appPages.push({
        title: 'Update Nachrichten',
        url: '/update-messages',
        photo: '../assets/flaticons/automation-applicants.png',
        disabled: false
      });
      this.appPages2.push({
        title: 'Update Nachrichten',
        url: '/update-messages',
        photo: '../assets/flaticons/automation-applicants.png',
        disabled: false
      });
    }

    // Add Admin Onboarding access for info@mona users (both admin and non-admin)
    if (this.isInfoMonaUser) {
      // Add to admin pages
      this.appPages.push({
        title: 'Admin Onboarding',
        url: '/admin-onboarding',
        icon: 'person-add',
        disabled: false
      });

      // Add to non-admin pages
      this.appPages2.push({
        title: 'Admin Onboarding',
        url: '/admin-onboarding',
        icon: 'person-add',
        disabled: false
      });
    }

    // this.appPages3 = [
    //   { title: this.translationObject['KIStudio'], url: '/get-data-for-ai', photo: '../assets/flaticons/automation-customers.png', disabled: false },
    // ]
    this.filterBasedOnPlan();
  }

  filterBasedOnPlan() {
    let currentPlan = this.customerDB.returnCurrentPlan();
    console.log("Current Plan: ", currentPlan);
    if (currentPlan !== "enterprise" && !currentPlan.includes("self-service")) {
      this.appPages = this.appPages.filter(item => item.url !== "/team-management");
      this.appPages = this.appPages.filter(item => item.url !== "/reporting");
      this.appPages = this.appPages.filter(item => item.url !== "/blacklist");
      this.appPages = this.appPages.filter(item => item.url !== "/workflows");
    }
    if (currentPlan.includes("self-service")) {
      this.appPages = this.appPages.filter(item => item.url !== "/team-management");
      this.appPages = this.appPages.filter(item => item.url !== "/reporting");
    }
  }







}


